const translate = {
  linked_field_tooltip: {
    en: 'Linked to',
    es: 'Vinculado a',
    fr: 'Lié à',
    de: 'Verknüpft mit',
    pt: 'Vinculado a',
    pl: 'Powiązane z',
    nl: 'Gekoppeld aan',
    el: 'Συνδεδεμένο με',
    cs: 'Propojeno s',
    sv: 'Länkat till',
    hu: 'Hozzárendelve',
    da: 'Linket til',
    fi: 'Yhdistetty',
    sk: 'Prepojené s',
    bg: 'Свързано с',
    hr: 'Povezano s',
    lt: 'Susieta su',
    lv: 'Saistīts ar',
    et: 'Lingitud',
    sl: 'Povezano z',
    ga: 'Nasctha le',
    mt: 'Marbut ma',
    cy: 'Wedi cysylltu â',
    ro: 'Legat de',
    it: 'Collegato a',
    zh_cn: '关联到',
    hi: 'से जुड़ा',
    ar: 'مرتبط بـ',
    bn: 'লিঙ্কড',
    ru: 'Связано с',
    ja: 'リンク先',
    tr: 'Bağlı',
    ko: '연결됨',
    vi: 'Liên kết với',
    id: 'Terhubung ke',
    th: 'เชื่อมโยงกับ',
    ms: 'Dipautkan ke',
    ar_eg: 'مرتبط بـ',
    uk: 'Пов’язано з',
  },
  add_content_toast: {
    en: 'Select a section (like header, footer, or body) from the left section panel before adding an element.',
    es: 'Seleccione una sección (como encabezado, pie de página o cuerpo) del panel de secciones de la izquierda antes de agregar un elemento.',
    fr: "Sélectionnez une section (comme l'en-tête, le pied de page ou le corps) à partir du panneau de sections à gauche avant d'ajouter un élément.",
    de: 'Wählen Sie einen Abschnitt (wie Kopfzeile, Fußzeile oder Hauptteil) aus dem linken Abschnittsbereich, bevor Sie ein Element hinzufügen.',
    pt: 'Selecione uma seção (como cabeçalho, rodapé ou corpo) no painel de seções à esquerda antes de adicionar um elemento.',
    pl: 'Wybierz sekcję (np. nagłówek, stopkę lub treść) z lewego panelu sekcji przed dodaniem elementu.',
    nl: 'Selecteer een sectie (zoals koptekst, voettekst of hoofdtekst) uit het linkerpaneel voordat u een element toevoegt.',
    el: 'Επιλέξτε μια ενότητα (όπως κεφαλίδα, υποσέλιδο ή σώμα) από τον αριστερό πίνακα ενοτήτων πριν προσθέσετε ένα στοιχείο.',
    cs: 'Vyberte sekci (například záhlaví, zápatí nebo tělo) z levého panelu sekcí před přidáním prvku.',
    sv: 'Välj en sektion (som rubrik, sidfot eller kropp) från vänster sektionspanel innan du lägger till ett element.',
    hu: 'Válasszon egy szakaszt (például fejlécek, láblécek vagy törzs) a bal oldali szekciópanelből, mielőtt elemet adna hozzá.',
    da: 'Vælg en sektion (som header, footer eller body) fra venstre sektionspanel, før du tilføjer et element.',
    fi: 'Valitse osa (kuten otsikko, alatunniste tai runko) vasemman osion paneelista ennen elementin lisäämistä.',
    sk: 'Vyberte sekciu (napríklad hlavičku, pätičku alebo telo) z ľavého panela sekcií pred pridaním prvku.',
    bg: 'Изберете секция (като заглавка, долен колонтитул или тяло) от левия панел със секции, преди да добавите елемент.',
    hr: 'Odaberite odjeljak (poput zaglavlja, podnožja ili tijela) s lijevog panela odjeljaka prije dodavanja elementa.',
    lt: 'Pasirinkite skyrių (pvz., antraštę, poraštę ar turinį) iš kairiojo skyrių skydelio prieš pridėdami elementą.',
    lv: 'Izvēlieties sadaļu (piemēram, galveni, kājeni vai korpusu) no kreisā paneļa pirms elementa pievienošanas.',
    et: 'Valige sektsioon (näiteks päis, jalus või sisu) vasakpoolsest sektsioonipaneelist enne elemendi lisamist.',
    sl: 'Izberite odsek (na primer glavo, nogo ali telo) iz levega podokna z odseki pred dodajanjem elementa.',
    ga: 'Roghnaigh alt (cosúil le ceanntásc, buntásc, nó comhlacht) ón bpainéal alt ar chlé sula gcuireann tú eilimint leis.',
    mt: 'Agħżel taqsima (bħal intestatura, footer, jew korp) mill-panel tat-taqsima tax-xellug qabel ma żżid element.',
    cy: 'Dewiswch adran (fel pennawd, troedyn neu gorff) o’r panel adran chwith cyn ychwanegu elfen.',
    ro: 'Selectați o secțiune (cum ar fi antet, subsol sau corp) din panoul de secțiuni din stânga înainte de a adăuga un element.',
    it: 'Seleziona una sezione (come intestazione, piè di pagina o corpo) dal pannello delle sezioni a sinistra prima di aggiungere un elemento.',
    zh_cn: '从左侧面板选择一个部分（如页眉、页脚或正文）后再添加元素。',
    hi: 'किसी अनुभाग (जैसे हेडर, फुटर या बॉडी) को बाएं सेक्शन पैनल से चुनें, फिर तत्व जोड़ें।',
    ar: 'اختر قسماً (مثل الرأس، التذييل أو النص) من لوحة الأقسام اليسرى قبل إضافة عنصر.',
    bn: 'একটি বিভাগ (যেমন হেডার, ফুটার বা বডি) বাম বিভাগের প্যানেল থেকে নির্বাচন করুন, তারপর একটি উপাদান যোগ করুন।',
    ru: 'Выберите раздел (например, заголовок, подвал или тело) на левой панели разделов перед добавлением элемента.',
    ja: '左セクションパネルからセクション（ヘッダー、フッター、または本文など）を選択してから要素を追加してください。',
    tr: 'Bir bölüm (başlık, alt bilgi veya gövde gibi) eklemeden önce sol bölüm panelinden seçin.',
    ko: '요소를 추가하기 전에 왼쪽 섹션 패널에서 섹션(헤더, 푸터 또는 본문)을 선택하세요.',
    vi: 'Chọn một phần (như tiêu đề, chân trang hoặc thân) từ bảng điều khiển phần bên trái trước khi thêm một phần tử.',
    id: 'Pilih sebuah bagian (seperti header, footer, atau body) dari panel bagian kiri sebelum menambahkan elemen.',
    th: 'เลือกส่วน (เช่น ส่วนหัว ส่วนท้าย หรือเนื้อหา) จากแผงส่วนทางซ้ายก่อนเพิ่มองค์ประกอบ',
    ms: 'Pilih bahagian (seperti pengepala, pengaki, atau badan) daripada panel bahagian kiri sebelum menambah elemen.',
    ar_eg: 'اختر قسماً (مثل الرأس، التذييل أو النص) من لوحة الأقسام اليسرى قبل إضافة عنصر.',
    uk: 'Виберіть розділ (наприклад, заголовок, нижній колонтитул або тіло) на лівій панелі розділів перед додаванням елемента.',
  },
  template_name: {
    en: 'Template Name',
    es: 'Nombre de Plantilla',
    fr: 'Nom du Modèle',
    de: 'Vorlagenname',
    pt: 'Nome do Modelo',
    pl: 'Nazwa Szablonu',
    nl: 'Sjabloonnaam',
    el: 'Όνομα Προτύπου',
    cs: 'Název Šablony',
    sv: 'Mallnamn',
    hu: 'Sablon Név',
    da: 'Skabelonnavn',
    fi: 'Mallin Nimi',
    sk: 'Názov Šablóny',
    bg: 'Име на Шаблон',
    hr: 'Naziv Predloška',
    lt: 'Šablono Pavadinimas',
    lv: 'Veidnes Nosaukums',
    et: 'Malli Nimi',
    sl: 'Ime Predloge',
    ga: 'Ainm Teimpléid',
    mt: 'Isem il-Mudell',
    cy: 'Enw Templed',
    ro: 'Nume Șablon',
    it: 'Nome del Modello',
    zh_cn: '模板名称',
    hi: 'टेम्पलेट का नाम',
    ar: 'اسم القالب',
    bn: 'টেম্পলেটের নাম',
    ru: 'Имя Шаблона',
    ja: 'テンプレート名',
    tr: 'Şablon Adı',
    ko: '템플릿 이름',
    vi: 'Tên Mẫu',
    id: 'Nama Template',
    th: 'ชื่อเทมเพลต',
    ms: 'Nama Templat',
    ar_eg: 'اسم القالب',
    uk: 'Назва Шаблону',
  },
  layers: {
    title: {
      en: 'Content Layers',
      es: 'Capas de Contenido',
      fr: 'Couches de Contenu',
      de: 'Inhaltsebenen',
      pt: 'Camadas de Conteúdo',
      pl: 'Warstwy Treści',
      nl: 'Inhoudslagen',
      el: 'Επίπεδα Περιεχομένου',
      cs: 'Vrstvy Obsahu',
      sv: 'Innehållslager',
      hu: 'Tartalmi Rétegek',
      da: 'Indholdslag',
      fi: 'Sisältökerrokset',
      sk: 'Vrstvy Obsahu',
      bg: 'Слоеве на Съдържание',
      hr: 'Slojevi Sadržaja',
      lt: 'Turinio Sluoksniai',
      lv: 'Satura Slāņi',
      et: 'Sisu Kihid',
      sl: 'Vsebinske Plasti',
      ga: 'Sraitheanna Ábhair',
      mt: 'Saffi tal-Kontenut',
      cy: 'Haenau Cynnwys',
      ro: 'Straturi de Conținut',
      it: 'Livelli di Contenuto',
      zh_cn: '内容层',
      hi: 'सामग्री परतें',
      ar: 'طبقات المحتوى',
      bn: 'বিষয়বস্তু স্তর',
      ru: 'Слои Контента',
      ja: 'コンテンツレイヤー',
      tr: 'İçerik Katmanları',
      ko: '콘텐츠 레이어',
      vi: 'Lớp Nội Dung',
      id: 'Lapisan Konten',
      th: 'เลเยอร์เนื้อหา',
      ms: 'Lapisan Kandungan',
      ar_eg: 'طبقات المحتوى',
      uk: 'Шари Вмісту',
    },

    delete: {
      title: {
        en: 'Are You Sure You Want to Delete This Layer?',
        es: '¿Estás Seguro de Que Quieres Eliminar Esta Capa?',
        fr: 'Êtes-Vous Sûr de Vouloir Supprimer Cette Couche ?',
        de: 'Sind Sie Sicher, Dass Sie Diese Ebene Löschen Möchten?',
        pt: 'Tem Certeza de Que Deseja Excluir Esta Camada?',
        pl: 'Czy Na Pewno Chcesz Usunąć Tę Warstwę?',
        nl: 'Weet U Zeker Dat U Deze Laag Wilt Verwijderen?',
        el: 'Είστε Σίγουροι ότι Θέλετε να Διαγράψετε Αυτό το Επίπεδο;',
        cs: 'Opravdu Chcete Smazat Tuto Vrstvu?',
        sv: 'Är Du Säker på att Du Vill Radera Detta Lager?',
        hu: 'Biztosan Törölni Szeretné Ezt a Réteget?',
        da: 'Er Du Sikker på, at Du Vil Slette Dette Lag?',
        fi: 'Oletko Varma, Että Haluat Poistaa Tämän Tason?',
        sk: 'Ste Si Istí, že Chcete Odstrániť Túto Vrstvu?',
        bg: 'Сигурни ли Сте, че Искате да Изтриете Този Слой?',
        hr: 'Jeste li Sigurni da Želite Izbrisati Ovaj Sloj?',
        lt: 'Ar Tikrai Norite Ištrinti Šį Sluoksnį?',
        lv: 'Vai Tiešām Vēlaties Dzēst Šo Slāni?',
        et: 'Kas Olete Kindel, et Soovite Selle Kihi Kustutada?',
        sl: 'Ali Ste Prepričani, da Želite Izbrisati To Plast?',
        ga: 'An Bhfuil Tú Cinnte Gur Mian Leat an Sraith Seo a Scriosadh?',
        mt: 'Żgur Li Trid Tħassar Din is-Saff?',
        cy: "Ydych Chi'n Siŵr Eich Bod Chi am Ddileu'r Haen Hwn?",
        ro: 'Sigur Vrei Să Ștergi Acest Strat?',
        it: 'Sei Sicuro di Voler Eliminare Questo Livello?',
        zh_cn: '您确定要删除此图层吗？',
        hi: 'क्या आप वाकई इस लेयर को हटाना चाहते हैं?',
        ar: 'هل أنت متأكد أنك تريد حذف هذه الطبقة؟',
        bn: 'আপনি কি নিশ্চিত যে আপনি এই স্তরটি মুছতে চান?',
        ru: 'Вы Уверены, что Хотите Удалить Этот Слой?',
        ja: 'このレイヤーを削除してもよろしいですか？',
        tr: 'Bu Katmanı Silmek İstediğinizden Emin misiniz?',
        ko: '이 레이어를 삭제하시겠습니까?',
        vi: 'Bạn Có Chắc Muốn Xóa Lớp Này Không?',
        id: 'Apakah Anda Yakin Ingin Menghapus Lapisan Ini?',
        th: 'คุณแน่ใจหรือไม่ว่าต้องการลบเลเยอร์นี้?',
        ms: 'Adakah Anda Pasti Mahu Memadam Lapisan Ini?',
        ar_eg: 'هل أنت متأكد أنك تريد حذف هذه الطبقة؟',
        uk: 'Ви Впевнені, що Хочете Видалити Цей Шар?',
      },

      yes: {
        en: 'Yes, Delete',
        es: 'Sí, Eliminar',
        fr: 'Oui, Supprimer',
        de: 'Ja, Löschen',
        pt: 'Sim, Excluir',
        pl: 'Tak, Usuń',
        nl: 'Ja, Verwijderen',
        el: 'Ναι, Διαγραφή',
        cs: 'Ano, Smazat',
        sv: 'Ja, Radera',
        hu: 'Igen, Törlés',
        da: 'Ja, Slet',
        fi: 'Kyllä, Poista',
        sk: 'Áno, Odstrániť',
        bg: 'Да, Изтрий',
        hr: 'Da, Izbriši',
        lt: 'Taip, Ištrinti',
        lv: 'Jā, Dzēst',
        et: 'Jah, Kustuta',
        sl: 'Da, Izbriši',
        ga: 'Tá, Scrios',
        mt: 'Iva, Ħassar',
        cy: 'Ie, Dileu',
        ro: 'Da, Șterge',
        it: 'Sì, Elimina',
        zh_cn: '是的，删除',
        hi: 'हां, हटाएं',
        ar: 'نعم، احذف',
        bn: 'হ্যাঁ, মুছুন',
        ru: 'Да, Удалить',
        ja: 'はい、削除',
        tr: 'Evet, Sil',
        ko: '예, 삭제',
        vi: 'Vâng, Xóa',
        id: 'Ya, Hapus',
        th: 'ใช่, ลบ',
        ms: 'Ya, Padam',
        ar_eg: 'نعم، احذف',
        uk: 'Так, Видалити',
      },
    },
    receipt_header: {
      en: 'Receipt Header',
      es: 'Encabezado del Recibo',
      fr: 'En-tête du Reçu',
      de: 'Belegkopf',
      pt: 'Cabeçalho do Recibo',
      pl: 'Nagłówek Paragonu',
      nl: 'Bonkop',
      el: 'Κεφαλίδα Απόδειξης',
      cs: 'Hlavička Účtenky',
      sv: 'Kvittorubrik',
      hu: 'Nyugta Fejléc',
      da: 'Kvitteringshoved',
      fi: 'Kuitin Otsikko',
      sk: 'Hlavička Príjmového Dokladu',
      bg: 'Заглавие на Разписка',
      hr: 'Zaglavlje Računa',
      lt: 'Kvitų Antraštė',
      lv: 'Kvīts Galvene',
      et: 'Kviitungi Päis',
      sl: 'Glava Računa',
      ga: 'Ceanntásc Admhála',
      mt: 'Intestatura tar-Riċevuta',
      cy: 'Pennawd Derbynneb',
      ro: 'Antetul Chitanței',
      it: 'Intestazione Ricevuta',
      zh_cn: '收据标题',
      hi: 'रसीद हेडर',
      ar: 'رأس الإيصال',
      bn: 'রসিদের শিরোনাম',
      ru: 'Заголовок Квитанции',
      ja: '領収書ヘッダー',
      tr: 'Makbuz Başlığı',
      ko: '영수증 헤더',
      vi: 'Tiêu Đề Biên Nhận',
      id: 'Header Kwitansi',
      th: 'ส่วนหัวของใบเสร็จ',
      ms: 'Pengepala Resit',
      ar_eg: 'رأس الإيصال',
      uk: 'Заголовок Квитанції',
    },
    receipt_column_titles: {
      en: 'Receipt Column Titles',
      es: 'Títulos de Columnas del Recibo',
      fr: 'Titres des Colonnes du Reçu',
      de: 'Spaltentitel des Belegs',
      pt: 'Títulos das Colunas do Recibo',
      pl: 'Tytuły Kolumn Paragonu',
      nl: 'Bon Kolomtitels',
      el: 'Τίτλοι Στηλών Απόδειξης',
      cs: 'Názvy Sloupců Účtenky',
      sv: 'Kolumnrubriker för Kvitto',
      hu: 'Nyugta Oszlop Címek',
      da: 'Kvitteringskolonnetitler',
      fi: 'Kuitin Sarakeotsikot',
      sk: 'Názvy Stĺpcov Príjmového Dokladu',
      bg: 'Заглавия на Колони на Разписката',
      hr: 'Naslovi Stupaca Računa',
      lt: 'Kvitų Stulpelių Pavadinimai',
      lv: 'Kvīts Kolonnu Nosaukumi',
      et: 'Kviitungi Veerupealkirjad',
      sl: 'Naslovi Stolpcev Računa',
      ga: 'Teidil Colúin Admhála',
      mt: 'Titoli tal-Kolonni tar-Riċevuta',
      cy: 'Teitlau Colofn Derbynneb',
      ro: 'Titluri de Coloană ale Chitanței',
      it: 'Titoli delle Colonne della Ricevuta',
      zh_cn: '收据列标题',
      hi: 'रसीद कॉलम शीर्षक',
      ar: 'عناوين أعمدة الإيصال',
      bn: 'রসিদের কলামের শিরোনাম',
      ru: 'Заголовки Столбцов Квитанции',
      ja: '領収書列タイトル',
      tr: 'Makbuz Sütun Başlıkları',
      ko: '영수증 열 제목',
      vi: 'Tiêu Đề Cột Biên Nhận',
      id: 'Judul Kolom Kwitansi',
      th: 'ชื่อคอลัมน์ใบเสร็จ',
      ms: 'Tajuk Lajur Resit',
      ar_eg: 'عناوين أعمدة الإيصال',
      uk: 'Заголовки Стовпців Квитанції',
    },

    receipt_body: {
      en: 'Receipt Body',
      es: 'Cuerpo del Recibo',
      fr: 'Corps du Reçu',
      de: 'Belegkörper',
      pt: 'Corpo do Recibo',
      pl: 'Treść Paragonu',
      nl: 'Bon Inhoud',
      el: 'Σώμα Απόδειξης',
      cs: 'Tělo Účtenky',
      sv: 'Kvittoinnehåll',
      hu: 'Nyugta Törzs',
      da: 'Kvitteringsindhold',
      fi: 'Kuitin Runko',
      sk: 'Telo Príjmového Dokladu',
      bg: 'Съдържание на Разписката',
      hr: 'Tijelo Računa',
      lt: 'Kvitų Turinys',
      lv: 'Kvīts Saturs',
      et: 'Kviitungi Sisu',
      sl: 'Telo Računa',
      ga: 'Corp Admhála',
      mt: 'Korp tar-Riċevuta',
      cy: 'Corff Derbynneb',
      ro: 'Corpul Chitanței',
      it: 'Corpo della Ricevuta',
      zh_cn: '收据主体',
      hi: 'रसीद बॉडी',
      ar: 'جسم الإيصال',
      bn: 'রসিদের মূল অংশ',
      ru: 'Тело Квитанции',
      ja: '領収書本文',
      tr: 'Makbuz Gövdesi',
      ko: '영수증 본문',
      vi: 'Nội Dung Biên Nhận',
      id: 'Isi Kwitansi',
      th: 'เนื้อหาใบเสร็จ',
      ms: 'Badan Resit',
      ar_eg: 'جسم الإيصال',
      uk: 'Основна Частина Квитанції',
    },

    payment_summary: {
      en: 'Payment Summary',
      es: 'Resumen de Pago',
      fr: 'Résumé de Paiement',
      de: 'Zahlungsübersicht',
      pt: 'Resumo de Pagamento',
      pl: 'Podsumowanie Płatności',
      nl: 'Betalingssamenvatting',
      el: 'Σύνοψη Πληρωμής',
      cs: 'Souhrn Platby',
      sv: 'Betalningssammanfattning',
      hu: 'Fizetési Összegzés',
      da: 'Betalingsoversigt',
      fi: 'Maksun Yhteenveto',
      sk: 'Súhrn Platby',
      bg: 'Обобщение на Плащането',
      hr: 'Sažetak Plaćanja',
      lt: 'Mokėjimo Santrauka',
      lv: 'Maksājuma Kopsavilkums',
      et: 'Makse Kokkuvõte',
      sl: 'Povzetek Plačila',
      ga: 'Achoimre Íocaíochta',
      mt: 'Sommarju tal-Ħlas',
      cy: 'Crynodeb Taliad',
      ro: 'Rezumatul Plății',
      it: 'Riepilogo Pagamento',
      zh_cn: '付款摘要',
      hi: 'भुगतान सारांश',
      ar: 'ملخص الدفع',
      bn: 'পেমেন্ট সারাংশ',
      ru: 'Сводка по Платежу',
      ja: '支払い概要',
      tr: 'Ödeme Özeti',
      ko: '결제 요약',
      vi: 'Tóm Tắt Thanh Toán',
      id: 'Ringkasan Pembayaran',
      th: 'สรุปการชำระเงิน',
      ms: 'Ringkasan Pembayaran',
      ar_eg: 'ملخص الدفع',
      uk: 'Підсумок Платежу',
    },

    footer: {
      en: 'Footer',
      es: 'Pie de Página',
      fr: 'Pied de Page',
      de: 'Fußzeile',
      pt: 'Rodapé',
      pl: 'Stopka',
      nl: 'Voettekst',
      el: 'Υποσέλιδο',
      cs: 'Patička',
      sv: 'Sidfot',
      hu: 'Lábléc',
      da: 'Sidefod',
      fi: 'Alatunniste',
      sk: 'Päta',
      bg: 'Долен Колонтитул',
      hr: 'Podnožje',
      lt: 'Poraštis',
      lv: 'Kājene',
      et: 'Jalus',
      sl: 'Noga',
      ga: 'Buntásc',
      mt: 'Footer',
      cy: 'Troedyn',
      ro: 'Subsol',
      it: 'Piè di Pagina',
      zh_cn: '页脚',
      hi: 'पाद लेख',
      ar: 'تذييل',
      bn: 'ফুটার',
      ru: 'Нижний Колонтитул',
      ja: 'フッター',
      tr: 'Altbilgi',
      ko: '바닥글',
      vi: 'Chân Trang',
      id: 'Footer',
      th: 'ส่วนท้าย',
      ms: 'Footer',
      ar_eg: 'تذييل',
      uk: 'Нижній Колонтитул',
    },
  },
  contents: {
    add_content: {
      en: 'Add Content',
      es: 'Agregar Contenido',
      fr: 'Ajouter du Contenu',
      de: 'Inhalt Hinzufügen',
      pt: 'Adicionar Conteúdo',
      pl: 'Dodaj Zawartość',
      nl: 'Inhoud Toevoegen',
      el: 'Προσθήκη Περιεχομένου',
      cs: 'Přidat Obsah',
      sv: 'Lägg till Innehåll',
      hu: 'Tartalom Hozzáadása',
      da: 'Tilføj Indhold',
      fi: 'Lisää Sisältöä',
      sk: 'Pridať Obsah',
      bg: 'Добавяне на Съдържание',
      hr: 'Dodaj Sadržaj',
      lt: 'Pridėti Turinį',
      lv: 'Pievienot Saturu',
      et: 'Lisa Sisu',
      sl: 'Dodaj Vsebino',
      ga: 'Cuir Ábhar Leis',
      mt: 'Żid Kontenut',
      cy: 'Ychwanegu Cynnwys',
      ro: 'Adăugați Conținut',
      it: 'Aggiungi Contenuto',
      zh_cn: '添加内容',
      hi: 'सामग्री जोड़ें',
      ar: 'إضافة محتوى',
      bn: 'বিষয়বস্তু যোগ করুন',
      ru: 'Добавить Контент',
      ja: 'コンテンツを追加',
      tr: 'İçerik Ekle',
      ko: '콘텐츠 추가',
      vi: 'Thêm Nội Dung',
      id: 'Tambahkan Konten',
      th: 'เพิ่มเนื้อหา',
      ms: 'Tambah Kandungan',
      ar_eg: 'إضافة محتوى',
      uk: 'Додати Вміст',
    },
    add_shape: {
      en: 'Add Shape',
      es: 'Agregar Forma',
      fr: 'Ajouter une Forme',
      de: 'Form Hinzufügen',
      pt: 'Adicionar Forma',
      pl: 'Dodaj Kształt',
      nl: 'Vorm Toevoegen',
      el: 'Προσθήκη Σχήματος',
      cs: 'Přidat Tvar',
      sv: 'Lägg till Form',
      hu: 'Alakzat Hozzáadása',
      da: 'Tilføj Form',
      fi: 'Lisää Muoto',
      sk: 'Pridať Tvar',
      bg: 'Добавяне на Форма',
      hr: 'Dodaj Oblik',
      lt: 'Pridėti Formą',
      lv: 'Pievienot Formu',
      et: 'Lisa Kujund',
      sl: 'Dodaj Obliko',
      ga: 'Cuir Cruth Leis',
      mt: 'Żid Forma',
      cy: 'Ychwanegu Siâp',
      ro: 'Adăugați Formă',
      it: 'Aggiungi Forma',
      zh_cn: '添加形状',
      hi: 'आकार जोड़ें',
      ar: 'إضافة شكل',
      bn: 'আকৃতি যোগ করুন',
      ru: 'Добавить Фигуру',
      ja: '図形を追加',
      tr: 'Şekil Ekle',
      ko: '도형 추가',
      vi: 'Thêm Hình Dạng',
      id: 'Tambahkan Bentuk',
      th: 'เพิ่มรูปร่าง',
      ms: 'Tambah Bentuk',
      ar_eg: 'إضافة شكل',
      uk: 'Додати Фігуру',
    },
    add_image: {
      en: 'Add Image',
      es: 'Agregar Imagen',
      fr: 'Ajouter une Image',
      de: 'Bild Hinzufügen',
      pt: 'Adicionar Imagem',
      pl: 'Dodaj Obraz',
      nl: 'Afbeelding Toevoegen',
      el: 'Προσθήκη Εικόνας',
      cs: 'Přidat Obrázek',
      sv: 'Lägg till Bild',
      hu: 'Kép Hozzáadása',
      da: 'Tilføj Billede',
      fi: 'Lisää Kuva',
      sk: 'Pridať Obrázok',
      bg: 'Добавяне на Изображение',
      hr: 'Dodaj Sliku',
      lt: 'Pridėti Paveikslėlį',
      lv: 'Pievienot Attēlu',
      et: 'Lisa Pilt',
      sl: 'Dodaj Sliko',
      ga: 'Cuir Íomhá Leis',
      mt: 'Żid Immaġni',
      cy: 'Ychwanegu Delwedd',
      ro: 'Adăugați Imagine',
      it: 'Aggiungi Immagine',
      zh_cn: '添加图片',
      hi: 'छवि जोड़ें',
      ar: 'إضافة صورة',
      bn: 'ছবি যোগ করুন',
      ru: 'Добавить Изображение',
      ja: '画像を追加',
      tr: 'Resim Ekle',
      ko: '이미지 추가',
      vi: 'Thêm Hình Ảnh',
      id: 'Tambahkan Gambar',
      th: 'เพิ่มรูปภาพ',
      ms: 'Tambah Imej',
      ar_eg: 'إضافة صورة',
      uk: 'Додати Зображення',
    },
    add_text: {
      en: 'Add Text',
      es: 'Agregar Texto',
      fr: 'Ajouter du Texte',
      de: 'Text Hinzufügen',
      pt: 'Adicionar Texto',
      pl: 'Dodaj Tekst',
      nl: 'Tekst Toevoegen',
      el: 'Προσθήκη Κειμένου',
      cs: 'Přidat Text',
      sv: 'Lägg till Text',
      hu: 'Szöveg Hozzáadása',
      da: 'Tilføj Tekst',
      fi: 'Lisää Teksti',
      sk: 'Pridať Text',
      bg: 'Добавяне на Текст',
      hr: 'Dodaj Tekst',
      lt: 'Pridėti Tekstą',
      lv: 'Pievienot Tekstu',
      et: 'Lisa Tekst',
      sl: 'Dodaj Besedilo',
      ga: 'Cuir Téacs Leis',
      mt: 'Żid Test',
      cy: 'Ychwanegu Testun',
      ro: 'Adăugați Text',
      it: 'Aggiungi Testo',
      zh_cn: '添加文本',
      hi: 'पाठ जोड़ें',
      ar: 'إضافة نص',
      bn: 'টেক্সট যোগ করুন',
      ru: 'Добавить Текст',
      ja: 'テキストを追加',
      tr: 'Metin Ekle',
      ko: '텍스트 추가',
      vi: 'Thêm Văn Bản',
      id: 'Tambahkan Teks',
      th: 'เพิ่มข้อความ',
      ms: 'Tambah Teks',
      ar_eg: 'إضافة نص',
      uk: 'Додати Текст',
    },
    shapes: {
      rectangle: {
        en: 'Rectangle',
        es: 'Rectángulo',
        fr: 'Rectangle',
        de: 'Rechteck',
        pt: 'Retângulo',
        pl: 'Prostokąt',
        nl: 'Rechthoek',
        el: 'Ορθογώνιο',
        cs: 'Obdélník',
        sv: 'Rektangel',
        hu: 'Téglalap',
        da: 'Rektangel',
        fi: 'Suorakulmio',
        sk: 'Obdĺžnik',
        bg: 'Правоъгълник',
        hr: 'Pravokutnik',
        lt: 'Stačiakampis',
        lv: 'Taisnstūris',
        et: 'Ristkülik',
        sl: 'Pravokotnik',
        ga: 'Dronuilleog',
        mt: 'Rettangolu',
        cy: 'Hirsgwâr',
        ro: 'Dreptunghi',
        it: 'Rettangolo',
        zh_cn: '矩形',
        hi: 'आयत',
        ar: 'مستطيل',
        bn: 'আয়তক্ষেত্র',
        ru: 'Прямоугольник',
        ja: '長方形',
        tr: 'Dikdörtgen',
        ko: '직사각형',
        vi: 'Hình Chữ Nhật',
        id: 'Persegi Panjang',
        th: 'สี่เหลี่ยมผืนผ้า',
        ms: 'Segi Empat Tepat',
        ar_eg: 'مستطيل',
        uk: 'Прямокутник',
      },
      circle: {
        en: 'Circle',
        es: 'Círculo',
        fr: 'Cercle',
        de: 'Kreis',
        pt: 'Círculo',
        pl: 'Okrąg',
        nl: 'Cirkel',
        el: 'Κύκλος',
        cs: 'Kruh',
        sv: 'Cirkel',
        hu: 'Kör',
        da: 'Cirkel',
        fi: 'Ympyrä',
        sk: 'Kruh',
        bg: 'Кръг',
        hr: 'Krug',
        lt: 'Apskritimas',
        lv: 'Aplis',
        et: 'Ring',
        sl: 'Krog',
        ga: 'Ciorcal',
        mt: 'Ċirku',
        cy: 'Cylch',
        ro: 'Cerc',
        it: 'Cerchio',
        zh_cn: '圆形',
        hi: 'वृत्त',
        ar: 'دائرة',
        bn: 'বৃত্ত',
        ru: 'Круг',
        ja: '円',
        tr: 'Daire',
        ko: '원',
        vi: 'Hình Tròn',
        id: 'Lingkaran',
        th: 'วงกลม',
        ms: 'Bulat',
        ar_eg: 'دائرة',
        uk: 'Коло',
      },
      line: {
        en: 'Line',
        es: 'Línea',
        fr: 'Ligne',
        de: 'Linie',
        pt: 'Linha',
        pl: 'Linia',
        nl: 'Lijn',
        el: 'Γραμμή',
        cs: 'Čára',
        sv: 'Linje',
        hu: 'Vonal',
        da: 'Linje',
        fi: 'Viiva',
        sk: 'Čiara',
        bg: 'Линия',
        hr: 'Linija',
        lt: 'Linija',
        lv: 'Līnija',
        et: 'Joon',
        sl: 'Črta',
        ga: 'Líne',
        mt: 'Linja',
        cy: 'Llinell',
        ro: 'Linie',
        it: 'Linea',
        zh_cn: '线',
        hi: 'रेखा',
        ar: 'خط',
        bn: 'রেখা',
        ru: 'Линия',
        ja: '線',
        tr: 'Çizgi',
        ko: '선',
        vi: 'Đường Thẳng',
        id: 'Garis',
        th: 'เส้น',
        ms: 'Garis',
        ar_eg: 'خط',
        uk: 'Лінія',
      },
      star: {
        en: 'Star',
        es: 'Estrella',
        fr: 'Étoile',
        de: 'Stern',
        pt: 'Estrela',
        pl: 'Gwiazda',
        nl: 'Ster',
        el: 'Αστέρι',
        cs: 'Hvězda',
        sv: 'Stjärna',
        hu: 'Csillag',
        da: 'Stjerne',
        fi: 'Tähti',
        sk: 'Hviezda',
        bg: 'Звезда',
        hr: 'Zvijezda',
        lt: 'Žvaigždė',
        lv: 'Zvaigzne',
        et: 'Täht',
        sl: 'Zvezda',
        ga: 'Réalt',
        mt: 'Stilla',
        cy: 'Seren',
        ro: 'Stea',
        it: 'Stella',
        zh_cn: '星形',
        hi: 'तारा',
        ar: 'نجمة',
        bn: 'তারকা',
        ru: 'Звезда',
        ja: '星',
        tr: 'Yıldız',
        ko: '별',
        vi: 'Ngôi Sao',
        id: 'Bintang',
        th: 'ดาว',
        ms: 'Bintang',
        ar_eg: 'نجمة',
        uk: 'Зірка',
      },

      setting_title: {
        en: 'Shape Setting',
        es: 'Configuración de Forma',
        fr: 'Paramètres de Forme',
        de: 'Formeinstellung',
        pt: 'Configuração de Forma',
        pl: 'Ustawienia Kształtu',
        nl: 'Vorminstelling',
        el: 'Ρύθμιση Σχήματος',
        cs: 'Nastavení Tvaru',
        sv: 'Forminställning',
        hu: 'Alak Beállítás',
        da: 'Formindstilling',
        fi: 'Muodon Asetus',
        sk: 'Nastavenie Tvaru',
        bg: 'Настройки на Форма',
        hr: 'Postavke Oblika',
        lt: 'Formos Nustatymai',
        lv: 'Formas Iestatījumi',
        et: 'Kujundi Seadistamine',
        sl: 'Nastavitve Oblike',
        ga: 'Socruithe Cruth',
        mt: 'Settings tal-Forma',
        cy: 'Gosodiadau Siâp',
        ro: 'Setări Formă',
        it: 'Impostazioni della Forma',
        zh_cn: '形状设置',
        hi: 'आकार सेटिंग',
        ar: 'إعدادات الشكل',
        bn: 'আকৃতির সেটিং',
        ru: 'Настройки Фигуры',
        ja: '図形設定',
        tr: 'Şekil Ayarı',
        ko: '도형 설정',
        vi: 'Cài Đặt Hình Dạng',
        id: 'Pengaturan Bentuk',
        th: 'การตั้งค่ารูปร่าง',
        ms: 'Tetapan Bentuk',
        ar_eg: 'إعدادات الشكل',
        uk: 'Налаштування Фігури',
      },
    },
    texts: {
      setting_title: {
        en: 'Text Setting',
        es: 'Configuración de Texto',
        fr: 'Paramètres de Texte',
        de: 'Texteinstellung',
        pt: 'Configuração de Texto',
        pl: 'Ustawienia Tekstu',
        nl: 'Tekstinstelling',
        el: 'Ρύθμιση Κειμένου',
        cs: 'Nastavení Textu',
        sv: 'Textinställning',
        hu: 'Szöveg Beállítás',
        da: 'Tekstindstilling',
        fi: 'Tekstiasetus',
        sk: 'Nastavenie Textu',
        bg: 'Настройки на Текста',
        hr: 'Postavke Teksta',
        lt: 'Teksto Nustatymai',
        lv: 'Teksta Iestatījumi',
        et: 'Teksti Seadistamine',
        sl: 'Nastavitve Besedila',
        ga: 'Socruithe Téacs',
        mt: 'Settings tat-Test',
        cy: 'Gosodiadau Testun',
        ro: 'Setări Text',
        it: 'Impostazioni del Testo',
        zh_cn: '文本设置',
        hi: 'पाठ सेटिंग',
        ar: 'إعدادات النص',
        bn: 'টেক্সট সেটিং',
        ru: 'Настройки Текста',
        ja: 'テキスト設定',
        tr: 'Metin Ayarı',
        ko: '텍스트 설정',
        vi: 'Cài Đặt Văn Bản',
        id: 'Pengaturan Teks',
        th: 'การตั้งค่าข้อความ',
        ms: 'Tetapan Teks',
        ar_eg: 'إعدادات النص',
        uk: 'Налаштування Тексту',
      },

      info: {
        title: {
          en: 'Info',
          es: 'Info',
          fr: 'Info',
          de: 'Info',
          pt: 'Info',
          pl: 'Info',
          nl: 'Info',
          el: 'Πληροφορίες',
          cs: 'Info',
          sv: 'Info',
          hu: 'Info',
          da: 'Info',
          fi: 'Info',
          sk: 'Info',
          bg: 'Информация',
          hr: 'Info',
          lt: 'Info',
          lv: 'Info',
          et: 'Info',
          sl: 'Info',
          ga: 'Eolas',
          mt: 'Info',
          cy: 'Gwybodaeth',
          ro: 'Info',
          it: 'Info',
          zh_cn: '信息',
          hi: 'जानकारी',
          ar: 'معلومات',
          bn: 'তথ্য',
          ru: 'Инфо',
          ja: '情報',
          tr: 'Bilgi',
          ko: '정보',
          vi: 'Thông Tin',
          id: 'Info',
          th: 'ข้อมูล',
          ms: 'Info',
          ar_eg: 'معلومات',
          uk: 'Інфо',
        },
        description: {
          en: 'Discount rate will apply always on any Item(s) that set with this discount rate and term, until you cancel or edit it.',
          es: 'La tasa de descuento se aplicará siempre a cualquier artículo que esté configurado con esta tasa de descuento y término, hasta que lo canceles o edites.',
          fr: "Le taux de réduction s'appliquera toujours à tout article configuré avec ce taux de réduction et ces conditions, jusqu'à ce que vous l'annuliez ou le modifiez.",
          de: 'Der Rabatt wird immer auf alle Artikel angewendet, die mit diesem Rabatt und dieser Bedingung festgelegt sind, bis Sie ihn stornieren oder bearbeiten.',
          pt: 'A taxa de desconto será sempre aplicada a qualquer item configurado com esta taxa de desconto e termo, até que você cancele ou edite.',
          pl: 'Stawka rabatu będzie zawsze stosowana do wszystkich przedmiotów ustawionych z tą stawką rabatu i warunkiem, dopóki jej nie anulujesz lub nie edytujesz.',
          nl: 'Het kortingspercentage wordt altijd toegepast op elk item dat is ingesteld met dit kortingspercentage en deze voorwaarde, totdat je het annuleert of wijzigt.',
          el: 'Ο συντελεστής έκπτωσης θα εφαρμόζεται πάντα σε οποιοδήποτε είδος που έχει οριστεί με αυτόν τον συντελεστή έκπτωσης και όρο, έως ότου το ακυρώσετε ή το επεξεργαστείτε.',
          cs: 'Sazba slevy bude vždy použita na všechny položky nastavené s touto sazbou a podmínkou, dokud ji nezrušíte nebo neupravíte.',
          sv: 'Rabatt kommer alltid att tillämpas på alla artiklar som är inställda med denna rabatt och villkor, tills du avbryter eller redigerar det.',
          hu: 'A kedvezményes ár mindig érvényes lesz minden olyan tételre, amely ezzel a kedvezményes árral és feltétellel van beállítva, amíg le nem mondja vagy szerkeszti.',
          da: 'Rabat vil altid gælde for varer, der er indstillet med denne rabat og betingelse, indtil du annullerer eller redigerer den.',
          fi: 'Alennusprosentti koskee aina kaikkia tuotteita, joille tämä alennusprosentti ja ehto on asetettu, kunnes peruutat tai muokkaat sitä.',
          sk: 'Zľavová sadzba sa vždy uplatní na všetky položky nastavené s touto zľavou a podmienkou, až kým ju nezrušíte alebo neupravíte.',
          bg: 'Ставката на отстъпка ще се прилага винаги за всички артикули, настроени с тази ставка на отстъпка и условие, докато не я отмените или редактирате.',
          hr: 'Stopa popusta uvijek će se primjenjivati na sve stavke postavljene s ovom stopom popusta i uvjetom, dok je ne otkažete ili uredite.',
          lt: 'Nuolaidos tarifas visada bus taikomas bet kokiems elementams, kuriems taikomas šis nuolaidos tarifas ir sąlygos, kol jų neatšauksite arba neredaguosite.',
          lv: 'Atlaides likme vienmēr tiks piemērota jebkuram vienumam, kuram ir noteikta šī atlaides likme un nosacījums, līdz to atceļat vai rediģējat.',
          et: 'Soodusmäär kehtib alati kõikidele üksustele, mis on määratud selle soodusmäära ja tingimusega, kuni te selle tühistate või muudate.',
          sl: 'Popustna stopnja bo vedno veljala za vse postavke, nastavljene s to popustno stopnjo in pogojem, dokler je ne prekličete ali uredite.',
          ga: 'Cuirfear an ráta lascaine i bhfeidhm i gcónaí ar aon mhír a leagtar síos leis an ráta lascaine agus an téarma seo, go dtí go gcealaíonn tú nó go n-athraíonn tú é.',
          mt: "Ir-rata ta' skont se tapplika dejjem fuq kwalunkwe oġġett li jiġi ssettjat b'dan ir-rata ta' skont u terminu, sakemm tħassar jew teditjah.",
          cy: "Bydd y gyfradd ddisgownt bob amser yn berthnasol i unrhyw Eitem(au) sydd wedi'u gosod gyda'r gyfradd a'r tymor disgownt hwn, nes i chi ei ganslo neu ei olygu.",
          ro: 'Rata de discount se va aplica întotdeauna oricăror articole setate cu această rată de discount și termen, până când o anulezi sau o editezi.',
          it: 'Il tasso di sconto verrà sempre applicato a qualsiasi articolo impostato con questa tariffa di sconto e termine, fino a quando non lo annulli o modifichi.',
          zh_cn: '折扣率将始终适用于任何设置了该折扣率和条款的商品，直到您取消或编辑它。',
          hi: 'यह छूट दर हमेशा उन सभी आइटमों पर लागू होगी जिन्हें इस छूट दर और शर्त के साथ सेट किया गया है, जब तक आप इसे रद्द या संपादित नहीं करते।',
          ar: 'سيتم تطبيق معدل الخصم دائمًا على أي عنصر تم تعيينه بهذا المعدل والشروط، حتى تقوم بإلغائه أو تحريره.',
          bn: 'এই ডিসকাউন্ট রেট এবং শর্ত সেট করা যেকোনো আইটেমে এই ডিসকাউন্ট রেট সর্বদা প্রযোজ্য হবে, যতক্ষণ না আপনি এটি বাতিল বা সম্পাদনা করেন।',
          ru: 'Ставка скидки всегда будет применяться ко всем товарам, установленным с этой ставкой скидки и условиями, пока вы не отмените или не измените ее.',
          ja: 'この割引率と条件で設定されたアイテムには、キャンセルまたは編集するまで常に割引率が適用されます。',
          tr: 'Bu indirim oranı ve koşulu ile ayarlanmış tüm ürünlere, iptal edene veya düzenleyene kadar her zaman uygulanır.',
          ko: '이 할인율과 조건이 설정된 모든 항목에 대해 취소하거나 편집할 때까지 항상 적용됩니다.',
          vi: 'Mức chiết khấu sẽ luôn được áp dụng cho bất kỳ mặt hàng nào được thiết lập với mức chiết khấu và điều khoản này, cho đến khi bạn hủy hoặc chỉnh sửa nó.',
          id: 'Tarif diskon akan selalu berlaku untuk item yang diatur dengan tarif dan syarat diskon ini, hingga Anda membatalkan atau mengeditnya.',
          th: 'อัตราส่วนลดจะใช้กับสินค้าทั้งหมดที่ตั้งค่าไว้ด้วยอัตราส่วนลดและเงื่อนไขนี้ จนกว่าคุณจะยกเลิกหรือแก้ไข',
          ms: 'Kadar diskaun akan sentiasa digunakan pada mana-mana Item yang ditetapkan dengan kadar diskaun dan terma ini, sehingga anda membatalkan atau mengeditnya.',
          ar_eg: 'سيتم تطبيق معدل الخصم دائمًا على أي عنصر تم تعيينه بهذا المعدل والشروط، حتى تقوم بإلغائه أو تحريره.',
          uk: 'Ставка знижки завжди буде застосовуватися до будь-яких елементів, налаштованих із цією ставкою знижки та умовою, доки ви не скасуєте або не зміните її.',
        },
      },

      set_custom_text: {
        en: 'Set Custom Text',
        es: 'Establecer Texto Personalizado',
        fr: 'Définir un Texte Personnalisé',
        de: 'Benutzerdefinierten Text Festlegen',
        pt: 'Definir Texto Personalizado',
        pl: 'Ustaw Tekst Niestandardowy',
        nl: 'Aangepaste Tekst Instellen',
        el: 'Ορίστε Προσαρμοσμένο Κείμενο',
        cs: 'Nastavit Vlastní Text',
        sv: 'Ställ in Anpassad Text',
        hu: 'Egyedi Szöveg Beállítása',
        da: 'Indstil Brugerdefineret Tekst',
        fi: 'Aseta Mukautettu Teksti',
        sk: 'Nastaviť Vlastný Text',
        bg: 'Задаване на Персонализиран Текст',
        hr: 'Postavi Prilagođeni Tekst',
        lt: 'Nustatyti Pasirinktinis Tekstas',
        lv: 'Iestatīt Pielāgotu Tekstu',
        et: 'Määra Kohandatud Tekst',
        sl: 'Nastavi Besedilo po Meri',
        ga: 'Socraigh Téacs Saincheaptha',
        mt: 'Issettja Test Personalizzat',
        cy: 'Gosod Testun Personol',
        ro: 'Setați Text Personalizat',
        it: 'Imposta Testo Personalizzato',
        zh_cn: '设置自定义文本',
        hi: 'कस्टम टेक्स्ट सेट करें',
        ar: 'تعيين نص مخصص',
        bn: 'কাস্টম টেক্সট সেট করুন',
        ru: 'Установить Пользовательский Текст',
        ja: 'カスタムテキストを設定',
        tr: 'Özel Metin Ayarla',
        ko: '사용자 정의 텍스트 설정',
        vi: 'Đặt Văn Bản Tùy Chỉnh',
        id: 'Atur Teks Kustom',
        th: 'ตั้งข้อความกำหนดเอง',
        ms: 'Tetapkan Teks Tersuai',
        ar_eg: 'تعيين نص مخصص',
        uk: 'Встановити Власний Текст',
      },

      connect_text_to_data_field: {
        en: 'Connect Text to Data Field',
        es: 'Conectar Texto al Campo de Datos',
        fr: 'Connecter le Texte au Champ de Données',
        de: 'Text mit Datenfeld Verbinden',
        pt: 'Conectar Texto ao Campo de Dados',
        pl: 'Połącz Tekst z Polem Danych',
        nl: 'Verbind Tekst met Gegevensveld',
        el: 'Σύνδεση Κειμένου με Πεδίο Δεδομένων',
        cs: 'Připojit Text k Datovému Poli',
        sv: 'Anslut Text till Datafält',
        hu: 'Szöveg Csatlakoztatása Adatmezőhöz',
        da: 'Forbind Tekst til Datafelt',
        fi: 'Yhdistä Teksti Tietokenttään',
        sk: 'Pripojiť Text k Dátovému Polu',
        bg: 'Свържете Текст с Поле за Данни',
        hr: 'Povežite Tekst s Poljem Podataka',
        lt: 'Prijungti Tekstą prie Duomenų Lauko',
        lv: 'Savienot Tekstu ar Datu Lauku',
        et: 'Ühenda Tekst Andmeväljaga',
        sl: 'Poveži Besedilo z Podatkovnim Poljem',
        ga: 'Ceangail Téacs le Réimse Sonraí',
        mt: "Qabbad Test ma' Qasam tad-Data",
        cy: 'Cysylltu Testun i Faes Data',
        ro: 'Conectați Textul la Câmpul de Date',
        it: 'Collega Testo al Campo Dati',
        zh_cn: '将文本连接到数据字段',
        hi: 'पाठ को डेटा फ़ील्ड से कनेक्ट करें',
        ar: 'ربط النص بحقل البيانات',
        bn: 'টেক্সটকে ডেটা ফিল্ডের সাথে সংযুক্ত করুন',
        ru: 'Подключить Текст к Полю Данных',
        ja: 'テキストをデータフィールドに接続',
        tr: 'Metni Veri Alanına Bağla',
        ko: '텍스트를 데이터 필드에 연결',
        vi: 'Kết Nối Văn Bản với Trường Dữ Liệu',
        id: 'Hubungkan Teks ke Field Data',
        th: 'เชื่อมต่อข้อความกับฟิลด์ข้อมูล',
        ms: 'Sambungkan Teks ke Medan Data',
        ar_eg: 'ربط النص بحقل البيانات',
        uk: 'Підключити Текст до Поля Даних',
      },

      items_table_options: {
        placeholder: {
          en: 'Select Category',
          es: 'Seleccionar categoría',
          fr: 'Sélectionner une catégorie',
          de: 'Kategorie auswählen',
          pt: 'Selecionar categoria',
          pl: 'Wybierz kategorię',
          nl: 'Selecteer categorie',
          el: 'Επιλέξτε κατηγορία',
          cs: 'Vyberte kategorii',
          sv: 'Välj kategori',
          hu: 'Kategória kiválasztása',
          da: 'Vælg kategori',
          fi: 'Valitse kategoria',
          sk: 'Vybrať kategóriu',
          bg: 'Изберете категория',
          hr: 'Odaberite kategoriju',
          lt: 'Pasirinkite kategoriją',
          lv: 'Izvēlēties kategoriju',
          et: 'Vali kategooria',
          sl: 'Izberite kategorijo',
          ga: 'Roghnaigh catagóir',
          mt: 'Agħżel kategorija',
          cy: 'Dewis Categori',
          ro: 'Selectați categoria',
          it: 'Seleziona categoria',
          zh_cn: '选择类别',
          hi: 'श्रेणी चुनें',
          ar: 'اختر الفئة',
          bn: 'বিভাগ নির্বাচন করুন',
          ru: 'Выберите категорию',
          ja: 'カテゴリーを選択',
          tr: 'Kategori Seç',
          ko: '카테고리 선택',
          vi: 'Chọn danh mục',
          id: 'Pilih Kategori',
          th: 'เลือกหมวดหมู่',
          ms: 'Pilih Kategori',
          ar_eg: 'اختر الفئة',
          uk: 'Вибрати категорію',
        },
        columns: {
          item_category: {
            en: 'Item Category',
            es: 'Categoría de artículo',
            fr: 'Catégorie d’article',
            de: 'Artikelkategorie',
            pt: 'Categoria do item',
            pl: 'Kategoria przedmiotu',
            nl: 'Artikelcategorie',
            el: 'Κατηγορία αντικειμένου',
            cs: 'Kategorie položky',
            sv: 'Artikelkategori',
            hu: 'Cikk kategória',
            da: 'Varekategori',
            fi: 'Tuoteryhmä',
            sk: 'Kategória položky',
            bg: 'Категория на артикула',
            hr: 'Kategorija artikla',
            lt: 'Prekės kategorija',
            lv: 'Preces kategorija',
            et: 'Toote kategooria',
            sl: 'Kategorija izdelka',
            ga: 'Catagóir míre',
            mt: 'Kategorija tal-oġġett',
            cy: 'Categori Eitem',
            ro: 'Categoria articolului',
            it: 'Categoria dell’articolo',
            zh_cn: '项目分类',
            hi: 'वस्तु श्रेणी',
            ar: 'فئة العنصر',
            bn: 'আইটেম বিভাগ',
            ru: 'Категория товара',
            ja: 'アイテムカテゴリ',
            tr: 'Ürün Kategorisi',
            ko: '항목 카테고리',
            vi: 'Danh mục sản phẩm',
            id: 'Kategori Item',
            th: 'หมวดหมู่สินค้า',
            ms: 'Kategori Item',
            ar_eg: 'فئة العنصر',
            uk: 'Категорія товару',
          },
          item_name: {
            en: 'Item Name',
            es: 'Nombre del artículo',
            fr: 'Nom de l’article',
            de: 'Artikelname',
            pt: 'Nome do item',
            pl: 'Nazwa przedmiotu',
            nl: 'Artikelnaam',
            el: 'Όνομα αντικειμένου',
            cs: 'Název položky',
            sv: 'Artikelnamn',
            hu: 'Cikknév',
            da: 'Varenavn',
            fi: 'Tuotenimi',
            sk: 'Názov položky',
            bg: 'Име на артикула',
            hr: 'Naziv artikla',
            lt: 'Prekės pavadinimas',
            lv: 'Preces nosaukums',
            et: 'Toote nimi',
            sl: 'Ime izdelka',
            ga: 'Ainm an mhír',
            mt: 'Isem tal-oġġett',
            cy: 'Enw Eitem',
            ro: 'Numele articolului',
            it: 'Nome dell’articolo',
            zh_cn: '项目名称',
            hi: 'वस्तु का नाम',
            ar: 'اسم العنصر',
            bn: 'আইটেমের নাম',
            ru: 'Название товара',
            ja: 'アイテム名',
            tr: 'Ürün Adı',
            ko: '항목 이름',
            vi: 'Tên mặt hàng',
            id: 'Nama Item',
            th: 'ชื่อสินค้า',
            ms: 'Nama Item',
            ar_eg: 'اسم العنصر',
            uk: 'Назва товару',
          },
        },
      },
    },

    shape: {
      en: 'Shape',
      es: 'Forma',
      fr: 'Forme',
      de: 'Form',
      pt: 'Forma',
      pl: 'Kształt',
      nl: 'Vorm',
      el: 'Σχήμα',
      cs: 'Tvar',
      sv: 'Form',
      hu: 'Alak',
      da: 'Form',
      fi: 'Muoto',
      sk: 'Tvar',
      bg: 'Форма',
      hr: 'Oblik',
      lt: 'Forma',
      lv: 'Forma',
      et: 'Kujund',
      sl: 'Oblika',
      ga: 'Cruth',
      mt: 'Forma',
      cy: 'Siâp',
      ro: 'Formă',
      it: 'Forma',
      zh_cn: '形状',
      hi: 'आकार',
      ar: 'شكل',
      bn: 'আকৃতি',
      ru: 'Форма',
      ja: '形状',
      tr: 'Şekil',
      ko: '모양',
      vi: 'Hình Dạng',
      id: 'Bentuk',
      th: 'รูปร่าง',
      ms: 'Bentuk',
      ar_eg: 'شكل',
      uk: 'Форма',
    },
    image: {
      en: 'Image',
      es: 'Imagen',
      fr: 'Image',
      de: 'Bild',
      pt: 'Imagem',
      pl: 'Obraz',
      nl: 'Afbeelding',
      el: 'Εικόνα',
      cs: 'Obrázek',
      sv: 'Bild',
      hu: 'Kép',
      da: 'Billede',
      fi: 'Kuva',
      sk: 'Obrázok',
      bg: 'Изображение',
      hr: 'Slika',
      lt: 'Vaizdas',
      lv: 'Attēls',
      et: 'Pilt',
      sl: 'Slika',
      ga: 'Íomhá',
      mt: 'Immaġni',
      cy: 'Delwedd',
      ro: 'Imagine',
      it: 'Immagine',
      zh_cn: '图片',
      hi: 'छवि',
      ar: 'صورة',
      bn: 'ছবি',
      ru: 'Изображение',
      ja: '画像',
      tr: 'Görüntü',
      ko: '이미지',
      vi: 'Hình Ảnh',
      id: 'Gambar',
      th: 'รูปภาพ',
      ms: 'Imej',
      ar_eg: 'صورة',
      uk: 'Зображення',
    },

    images: {
      setting_title: {
        en: 'Image Setting',
        es: 'Configuración de Imagen',
        fr: "Paramètres de l'Image",
        de: 'Bildeinstellung',
        pt: 'Configuração de Imagem',
        pl: 'Ustawienia Obrazu',
        nl: 'Afbeeldingsinstelling',
        el: 'Ρύθμιση Εικόνας',
        cs: 'Nastavení Obrázku',
        sv: 'Bildinställning',
        hu: 'Kép Beállítás',
        da: 'Billedindstilling',
        fi: 'Kuva-asetus',
        sk: 'Nastavenie Obrázka',
        bg: 'Настройки на Изображението',
        hr: 'Postavke Slike',
        lt: 'Vaizdo Nustatymai',
        lv: 'Attēla Iestatījumi',
        et: 'Pildi Seadistamine',
        sl: 'Nastavitve Slike',
        ga: 'Socruithe Íomhá',
        mt: 'Settings tal-Immaġni',
        cy: 'Gosodiadau Delwedd',
        ro: 'Setări Imagine',
        it: "Impostazioni dell'Immagine",
        zh_cn: '图片设置',
        hi: 'छवि सेटिंग',
        ar: 'إعدادات الصورة',
        bn: 'ছবির সেটিং',
        ru: 'Настройки Изображения',
        ja: '画像設定',
        tr: 'Görüntü Ayarı',
        ko: '이미지 설정',
        vi: 'Cài Đặt Hình Ảnh',
        id: 'Pengaturan Gambar',
        th: 'การตั้งค่ารูปภาพ',
        ms: 'Tetapan Imej',
        ar_eg: 'إعدادات الصورة',
        uk: 'Налаштування Зображення',
      },

      warning: {
        title: {
          en: 'Important Note',
          es: 'Nota Importante',
          fr: 'Note Importante',
          de: 'Wichtiger Hinweis',
          pt: 'Nota Importante',
          pl: 'Ważna Uwaga',
          nl: 'Belangrijke Opmerking',
          el: 'Σημαντική Σημείωση',
          cs: 'Důležitá Poznámka',
          sv: 'Viktig Notering',
          hu: 'Fontos Megjegyzés',
          da: 'Vigtig Bemærkning',
          fi: 'Tärkeä Huomautus',
          sk: 'Dôležitá Poznámka',
          bg: 'Важна Забележка',
          hr: 'Važna Napomena',
          lt: 'Svarbi Pastaba',
          lv: 'Svarīga Piezīme',
          et: 'Oluline Märkus',
          sl: 'Pomembna Opomba',
          ga: 'Nóta Tábhachtach',
          mt: 'Nota Importanti',
          cy: 'Nodyn Pwysig',
          ro: 'Notă Importantă',
          it: 'Nota Importante',
          zh_cn: '重要提示',
          hi: 'महत्वपूर्ण नोट',
          ar: 'ملاحظة هامة',
          bn: 'গুরুত্বপূর্ণ নোট',
          ru: 'Важное Примечание',
          ja: '重要な注意',
          tr: 'Önemli Not',
          ko: '중요한 메모',
          vi: 'Lưu Ý Quan Trọng',
          id: 'Catatan Penting',
          th: 'หมายเหตุสำคัญ',
          ms: 'Nota Penting',
          ar_eg: 'ملاحظة هامة',
          uk: 'Важлива Примітка',
        },
        description: {
          en: 'Remember to use only black & white images. Heat-based printers work by selectively heating areas of thermal paper to create images. A black and white logo ensures clear, consistent results on this sensitive medium.',
          es: 'Recuerde usar solo imágenes en blanco y negro. Las impresoras térmicas funcionan calentando selectivamente áreas del papel térmico para crear imágenes. Un logotipo en blanco y negro garantiza resultados claros y consistentes en este medio sensible.',
          fr: "N'oubliez pas d'utiliser uniquement des images en noir et blanc. Les imprimantes thermiques fonctionnent en chauffant sélectivement des zones de papier thermique pour créer des images. Un logo en noir et blanc garantit des résultats clairs et cohérents sur ce support sensible.",
          de: 'Denken Sie daran, nur schwarz-weiße Bilder zu verwenden. Thermodrucker arbeiten, indem sie gezielt Bereiche des Thermopapiers erhitzen, um Bilder zu erzeugen. Ein schwarz-weißes Logo sorgt für klare, konsistente Ergebnisse auf diesem empfindlichen Medium.',
          pt: 'Lembre-se de usar apenas imagens em preto e branco. Impressoras térmicas funcionam aquecendo seletivamente áreas do papel térmico para criar imagens. Um logotipo em preto e branco garante resultados claros e consistentes neste meio sensível.',
          pl: 'Pamiętaj, aby używać tylko czarno-białych obrazów. Drukarki termiczne działają poprzez selektywne podgrzewanie obszarów papieru termicznego w celu tworzenia obrazów. Czarno-białe logo zapewnia wyraźne, spójne wyniki na tym wrażliwym nośniku.',
          nl: 'Vergeet niet alleen zwart-wit afbeeldingen te gebruiken. Thermische printers werken door selectief gebieden van thermisch papier te verwarmen om afbeeldingen te creëren. Een zwart-wit logo zorgt voor duidelijke, consistente resultaten op dit gevoelige medium.',
          el: 'Θυμηθείτε να χρησιμοποιείτε μόνο ασπρόμαυρες εικόνες. Οι θερμικοί εκτυπωτές λειτουργούν θερμαίνοντας επιλεκτικά περιοχές θερμικού χαρτιού για τη δημιουργία εικόνων. Ένα ασπρόμαυρο λογότυπο εξασφαλίζει καθαρά, συνεπή αποτελέσματα σε αυτό το ευαίσθητο μέσο.',
          cs: 'Pamatujte, že je třeba používat pouze černobílé obrázky. Termální tiskárny pracují selektivním zahříváním oblastí termálního papíru k vytváření obrázků. Černobílé logo zajišťuje jasné a konzistentní výsledky na tomto citlivém médiu.',
          sv: 'Kom ihåg att endast använda svartvita bilder. Värmebaserade skrivare fungerar genom att selektivt värma upp områden av termiskt papper för att skapa bilder. En svartvit logotyp ger tydliga, konsekventa resultat på detta känsliga medium.',
          hu: 'Ne feledje, hogy csak fekete-fehér képeket használjon. Hőalapú nyomtatók szelektíven melegítik a hőpapír bizonyos részeit a képek létrehozásához. Egy fekete-fehér logó tiszta, egyenletes eredményeket biztosít ezen az érzékeny közegen.',
          da: 'Husk kun at bruge sort/hvide billeder. Varmebaserede printere fungerer ved selektivt at opvarme områder af termisk papir for at skabe billeder. Et sort/hvidt logo sikrer klare, konsistente resultater på dette følsomme medium.',
          fi: 'Muista käyttää vain mustavalkoisia kuvia. Lämpötulostimet toimivat valikoivasti lämmittämällä lämpöpaperin alueita kuvien luomiseksi. Mustavalkoinen logo takaa selkeät, johdonmukaiset tulokset tällä herkällä materiaalilla.',
          sk: 'Pamätajte, že je potrebné používať iba čiernobiele obrázky. Tepelné tlačiarne fungujú selektívnym zahrievaním oblastí tepelného papiera na vytváranie obrázkov. Čiernobiele logo zabezpečuje jasné a konzistentné výsledky na tomto citlivom médiu.',
          bg: 'Не забравяйте да използвате само черно-бели изображения. Термопринтерите работят чрез селективно нагряване на зони от термохартия за създаване на изображения. Черно-бялото лого осигурява ясни, последователни резултати на този чувствителен носител.',
          hr: 'Ne zaboravite koristiti samo crno-bijele slike. Termalni pisači rade selektivnim zagrijavanjem područja termalnog papira za stvaranje slika. Crno-bijeli logotip osigurava jasne, dosljedne rezultate na ovom osjetljivom mediju.',
          lt: 'Nepamirškite naudoti tik juodai baltų vaizdų. Šiluminiai spausdintuvai veikia selektyviai šildydami šiluminio popieriaus plotus, kad sukurtų vaizdus. Juodai baltas logotipas užtikrina aiškius, nuoseklius rezultatus šioje jautrioje terpėje.',
          lv: 'Atcerieties izmantot tikai melnbaltus attēlus. Siltuma printeri darbojas, selektīvi uzkarsējot termopapīra apgabalus, lai radītu attēlus. Melnbalts logotips nodrošina skaidrus, konsekventus rezultātus šajā jutīgajā materiālā.',
          et: 'Pea meeles kasutada ainult mustvalgeid pilte. Soojusprinterid töötavad, kuumutades valikuliselt termopaberi alasid, et luua pilte. Mustvalge logo tagab selged, ühtlased tulemused sellel tundlikul kandjal.',
          sl: 'Ne pozabite uporabljati samo črno-belih slik. Toplotni tiskalniki delujejo tako, da selektivno segrevajo območja termičnega papirja za ustvarjanje slik. Črno-beli logotip zagotavlja jasne, dosledne rezultate na tem občutljivem mediju.',
          ga: 'Cuimhnigh úsáid a bhaint as íomhánna dubh agus bán amháin. Oibríonn printéirí teasa trí limistéir áirithe de pháipéar teirmeach a théamh go roghnach chun íomhánna a chruthú. Cinntíonn lógó dubh agus bán torthaí soiléire, comhsheasmhacha ar an meán íogair seo.',
          mt: "Ftakar li tuża biss immaġini suwed u bojod. Il-printers ibbażati fuq is-sħana jaħdmu billi jsaħħnu b'mod selettiv żoni ta' karta termika biex joħolqu immaġini. Logo iswed u abjad jiżgura riżultati ċari u konsistenti f'dan il-mezz sensittiv.",
          cy: 'Cofiwch ddefnyddio delweddau du a gwyn yn unig. Mae argraffwyr thermol yn gweithio trwy wresogi ardaloedd dethol o bapur thermol i greu delweddau. Mae logo du a gwyn yn sicrhau canlyniadau clir, cyson ar y cyfrwng sensitif hwn.',
          ro: 'Amintiți-vă să folosiți doar imagini alb-negru. Imprimantele termice funcționează prin încălzirea selectivă a unor zone de hârtie termică pentru a crea imagini. Un logo alb-negru asigură rezultate clare și consistente pe acest mediu sensibil.',
          it: 'Ricordati di utilizzare solo immagini in bianco e nero. Le stampanti termiche funzionano riscaldando selettivamente aree di carta termica per creare immagini. Un logo in bianco e nero garantisce risultati chiari e coerenti su questo supporto sensibile.',
          zh_cn:
            '请务必仅使用黑白图像。热敏打印机通过选择性加热热敏纸的特定区域来生成图像。黑白标志可确保在这种敏感介质上获得清晰、一致的效果。',
          hi: 'केवल काले और सफेद चित्रों का ही उपयोग करें। थर्मल प्रिंटर तापीय कागज के क्षेत्रों को चुनिंदा रूप से गर्म करके चित्र बनाते हैं। एक काले और सफेद लोगो इस संवेदनशील माध्यम पर स्पष्ट, सुसंगत परिणाम सुनिश्चित करता है।',
          ar: 'تذكر استخدام الصور بالأبيض والأسود فقط. تعمل الطابعات الحرارية عن طريق تسخين مناطق محددة من الورق الحراري لإنشاء الصور. يضمن الشعار بالأبيض والأسود نتائج واضحة ومتسقة على هذا الوسط الحساس.',
          bn: 'শুধুমাত্র সাদা-কালো চিত্র ব্যবহার করতে মনে রাখবেন। তাপ-ভিত্তিক প্রিন্টারগুলি চিত্র তৈরি করতে থার্মাল পেপারের নির্দিষ্ট অঞ্চলে নির্বাচনীভাবে তাপ প্রদান করে। একটি সাদা-কালো লোগো এই সংবেদনশীল মাধ্যমে পরিষ্কার, সামঞ্জস্যপূর্ণ ফলাফল নিশ্চিত করে।',
          ru: 'Помните, используйте только черно-белые изображения. Термопринтеры работают, выборочно нагревая участки термобумаги для создания изображений. Черно-белый логотип обеспечивает четкие и стабильные результаты на этом чувствительном носителе.',
          ja: '白黒の画像のみを使用することを忘れないでください。熱転写プリンタは、感熱紙の特定の部分を選択的に加熱して画像を作成します。白黒のロゴは、この敏感なメディアで明確で一貫した結果を保証します。',
          tr: 'Yalnızca siyah-beyaz görseller kullanmayı unutmayın. Isı bazlı yazıcılar, görüntü oluşturmak için termal kağıdın belirli bölgelerini seçici olarak ısıtarak çalışır. Siyah-beyaz bir logo, bu hassas ortamda net ve tutarlı sonuçlar sağlar.',
          ko: '흑백 이미지만 사용해야 합니다. 열 기반 프린터는 열 감지 종이의 특정 영역을 선택적으로 가열하여 이미지를 만듭니다. 흑백 로고는 이 민감한 매체에서 선명하고 일관된 결과를 보장합니다.',
          vi: 'Nhớ chỉ sử dụng hình ảnh đen trắng. Máy in nhiệt hoạt động bằng cách chọn lọc làm nóng các khu vực của giấy nhiệt để tạo hình ảnh. Logo đen trắng đảm bảo kết quả rõ ràng, nhất quán trên loại phương tiện nhạy cảm này.',
          id: 'Ingat untuk hanya menggunakan gambar hitam & putih. Printer berbasis panas bekerja dengan memanaskan area kertas termal secara selektif untuk membuat gambar. Logo hitam putih memastikan hasil yang jelas dan konsisten pada media yang sensitif ini.',
          th: 'จำไว้ว่าให้ใช้เฉพาะภาพขาวดำเท่านั้น เครื่องพิมพ์แบบใช้ความร้อนทำงานโดยการให้ความร้อนแก่ส่วนของกระดาษเทอร์มอลเพื่อสร้างภาพ โลโก้ขาวดำช่วยให้ได้ผลลัพธ์ที่ชัดเจนและสม่ำเสมอบนสื่อนี้',
          ms: 'Ingat untuk hanya menggunakan imej hitam & putih. Pencetak berasaskan haba berfungsi dengan memanaskan kawasan kertas termal secara selektif untuk mencipta imej. Logo hitam dan putih memastikan hasil yang jelas dan konsisten pada medium sensitif ini.',
          ar_eg:
            'تذكر استخدام الصور بالأبيض والأسود فقط. تعمل الطابعات الحرارية عن طريق تسخين مناطق محددة من الورق الحراري لإنشاء الصور. يضمن الشعار بالأبيض والأسود نتائج واضحة ومتسقة على هذا الوسط الحساس.',
          uk: "Пам'ятайте використовувати лише чорно-білі зображення. Термопринтери працюють, вибірково нагріваючи ділянки термопаперу для створення зображень. Чорно-білий логотип забезпечує чіткі та стабільні результати на цьому чутливому носії.",
        },
      },

      info: {
        title: {
          en: 'Quick Tip',
          es: 'Consejo Rápido',
          fr: 'Astuces Rapides',
          de: 'Schneller Tipp',
          pt: 'Dica Rápida',
          pl: 'Szybka Porada',
          nl: 'Snelle Tip',
          el: 'Γρήγορη Συμβουλή',
          cs: 'Rychlý Tip',
          sv: 'Snabbtips',
          hu: 'Gyors Tipp',
          da: 'Hurtigt Tip',
          fi: 'Nopea Vinkki',
          sk: 'Rýchly Tip',
          bg: 'Бърз Съвет',
          hr: 'Brzi Savjet',
          lt: 'Greitas Patarimas',
          lv: 'Ātrs Padoms',
          et: 'Kiire Nõuanne',
          sl: 'Hiter Nasvet',
          ga: 'Leid Thapa',
          mt: 'Parir Malajr',
          cy: 'Awgrym Cyflym',
          ro: 'Sfat Rapid',
          it: 'Suggerimento Rapido',
          zh_cn: '快速提示',
          hi: 'त्वरित सुझाव',
          ar: 'نصيحة سريعة',
          bn: 'দ্রুত পরামর্শ',
          ru: 'Быстрый Совет',
          ja: 'クイックヒント',
          tr: 'Hızlı İpucu',
          ko: '빠른 팁',
          vi: 'Mẹo Nhanh',
          id: 'Tip Cepat',
          th: 'เคล็ดลับด่วน',
          ms: 'Petua Pantas',
          ar_eg: 'نصيحة سريعة',
          uk: 'Швидка Порада',
        },
        description: {
          en: 'You can add a custom photo to your receipt template, which will be printed exactly as uploaded, or you can link it to your data to dynamically appear in the final printed or e-receipt. Please note that colourful images cannot be printed on thermal printers.',
          es: 'Puede agregar una foto personalizada a su plantilla de recibo, que se imprimirá exactamente como se cargó, o puede vincularla a sus datos para que aparezca dinámicamente en el recibo impreso o electrónico final. Tenga en cuenta que las imágenes en color no se pueden imprimir en impresoras térmicas.',
          fr: "Vous pouvez ajouter une photo personnalisée à votre modèle de reçu, qui sera imprimée exactement comme téléchargée, ou vous pouvez la lier à vos données pour qu'elle apparaisse dynamiquement sur le reçu final imprimé ou électronique. Veuillez noter que les images en couleur ne peuvent pas être imprimées sur des imprimantes thermiques.",
          de: 'Sie können ein benutzerdefiniertes Foto zu Ihrer Belegvorlage hinzufügen, das genau wie hochgeladen gedruckt wird, oder Sie können es mit Ihren Daten verknüpfen, damit es dynamisch auf dem endgültigen gedruckten oder elektronischen Beleg erscheint. Bitte beachten Sie, dass Farbbilder nicht auf Thermodruckern gedruckt werden können.',
          pt: 'Você pode adicionar uma foto personalizada ao seu modelo de recibo, que será impressa exatamente como enviada, ou pode vinculá-la aos seus dados para aparecer dinamicamente no recibo impresso ou eletrônico final. Observe que imagens coloridas não podem ser impressas em impressoras térmicas.',
          pl: 'Możesz dodać niestandardowe zdjęcie do swojego szablonu paragonu, które zostanie wydrukowane dokładnie tak, jak zostało przesłane, lub możesz je powiązać ze swoimi danymi, aby dynamicznie pojawiało się na końcowym wydrukowanym lub e-paragonie. Należy pamiętać, że kolorowe obrazy nie mogą być drukowane na drukarkach termicznych.',
          nl: 'U kunt een aangepaste foto toevoegen aan uw kassabon-sjabloon, die precies zoals geüpload wordt afgedrukt, of u kunt deze koppelen aan uw gegevens zodat deze dynamisch verschijnt op de uiteindelijke gedrukte of elektronische bon. Houd er rekening mee dat gekleurde afbeeldingen niet kunnen worden afgedrukt op thermische printers.',
          el: 'Μπορείτε να προσθέσετε μια προσαρμοσμένη φωτογραφία στο πρότυπο της απόδειξής σας, η οποία θα εκτυπωθεί ακριβώς όπως έχει φορτωθεί ή μπορείτε να τη συνδέσετε με τα δεδομένα σας ώστε να εμφανίζεται δυναμικά στην τελική εκτυπωμένη ή ηλεκτρονική απόδειξη. Σημειώστε ότι οι έγχρωμες εικόνες δεν μπορούν να εκτυπωθούν σε θερμικούς εκτυπωτές.',
          cs: 'Můžete přidat vlastní fotografii do své šablony účtenky, která bude vytištěna přesně tak, jak byla nahrána, nebo ji můžete propojit se svými daty, aby se dynamicky zobrazovala na konečné tištěné nebo elektronické účtence. Upozorňujeme, že barevné obrázky nelze tisknout na termotiskárnách.',
          sv: 'Du kan lägga till ett anpassat foto i din kvittomall, som kommer att skrivas ut precis som det laddades upp, eller så kan du länka det till din data för att dynamiskt visas på det slutliga tryckta eller e-kvittot. Observera att färgbilder inte kan skrivas ut på termiska skrivare.',
          hu: 'Egyedi fényképet adhat a számlasablonjához, amely pontosan úgy kerül kinyomtatásra, ahogyan feltöltötte, vagy összekapcsolhatja azt az adataival, hogy dinamikusan jelenjen meg a végső nyomtatott vagy elektronikus számlán. Kérjük, vegye figyelembe, hogy a színes képek nem nyomtathatók hőnyomtatókon.',
          da: 'Du kan tilføje et brugerdefineret foto til din kvitteringsskabelon, som vil blive udskrevet præcis som uploadet, eller du kan linke det til dine data, så det dynamisk vises på den endelige udskrevne eller e-kvittering. Bemærk, at farvebilleder ikke kan udskrives på termoprintere.',
          fi: 'Voit lisätä mukautetun valokuvan kuittipohjaasi, joka tulostetaan täsmälleen sellaisena kuin se on ladattu, tai voit linkittää sen tietoihisi niin, että se näkyy dynaamisesti lopullisessa tulostetussa tai sähköisessä kuitissa. Huomaa, että värikuvia ei voida tulostaa lämpökirjoittimilla.',
          sk: 'Môžete pridať vlastnú fotografiu do svojej šablóny účtenky, ktorá bude vytlačená presne tak, ako bola nahraná, alebo ju môžete prepojiť so svojimi údajmi, aby sa dynamicky zobrazovala na konečnej vytlačenej alebo elektronickej účtenke. Upozorňujeme, že farebné obrázky nemožno tlačiť na termotlačiarňach.',
          bg: 'Можете да добавите персонализирана снимка към вашия шаблон за касова бележка, която ще бъде отпечатана точно както е качена, или можете да я свържете с вашите данни, за да се появява динамично на окончателната отпечатана или електронна бележка. Моля, обърнете внимание, че цветни изображения не могат да се отпечатват на термични принтери.',
          hr: 'Možete dodati prilagođenu fotografiju u svoj predložak računa, koja će biti ispisana točno onako kako je učitana, ili je možete povezati sa svojim podacima kako bi se dinamički pojavila na konačnom ispisanom ili e-računu. Imajte na umu da se slike u boji ne mogu ispisivati na termalnim pisačima.',
          lt: 'Galite pridėti pasirinktą nuotrauką prie savo kvito šablono, kuri bus atspausdinta tiksliai taip, kaip buvo įkelta, arba galite susieti ją su savo duomenimis, kad ji dinamiškai pasirodytų galutiniame atspausdintame ar elektroniniame kvite. Atkreipkite dėmesį, kad spalvoti vaizdai negali būti spausdinami terminiais spausdintuvais.',
          lv: 'Jūs varat pievienot pielāgotu fotoattēlu savai kvīts veidnei, kas tiks izdrukāta tieši tā, kā tika augšupielādēta, vai varat to saistīt ar saviem datiem, lai tas dinamiski parādītos galīgajā izdrukātajā vai elektroniskajā kvītī. Lūdzu, ņemiet vērā, ka krāsainus attēlus nevar izdrukāt uz termoprinteriem.',
          et: 'Saate lisada oma kviitungi mallile kohandatud foto, mis prinditakse täpselt nii, nagu see üles laaditi, või saate selle oma andmetega linkida, et see ilmuks dünaamiliselt lõplikul prinditud või e-kviitungil. Pange tähele, et värvilisi pilte ei saa termoprinteritega printida.',
          sl: 'V svojo predlogo računa lahko dodate prilagojeno fotografijo, ki bo natisnjena točno tako, kot je bila naložena, ali jo lahko povežete s svojimi podatki, da se dinamično prikaže na končnem natisnjenem ali e-računu. Upoštevajte, da barvnih slik ni mogoče natisniti na termičnih tiskalnikih.',
          ga: 'Is féidir leat grianghraf saincheaptha a chur le do theimpléad admhála, a phriontálfar go díreach mar a uaslódáladh é, nó is féidir leat é a nascadh le do shonraí ionas go bhfeicfidh sé go dinimiciúil san admháil chlóite nó leictreonach deiridh. Tabhair faoi deara nach féidir íomhánna daite a phriontáil ar phrintéirí teirmeacha.',
          mt: "Tista' żżid ritratt personalizzat mat-template tar-ricetta tiegħek, li jiġi stampat eżattament kif ittella', jew tista' torbotu mad-dejta tiegħek sabiex jidher b'mod dinamiku fuq l-irċevuta stampata jew elettronika finali. Jekk jogħġbok innota li immaġini kkuluriti ma jistgħux jiġu stampati fuq printers termali.",
          cy: "Gallwch ychwanegu llun personol at eich templed derbynneb, a fydd yn cael ei argraffu'n union fel y'i llwythwyd, neu gallwch ei gysylltu â'ch data i ymddangos yn ddeinamig ar y derbynneb printiedig neu electronig terfynol. Sylwch na ellir argraffu delweddau lliw ar brintwyr thermol.",
          ro: 'Puteți adăuga o fotografie personalizată la șablonul dvs. de chitanță, care va fi tipărită exact așa cum a fost încărcată, sau o puteți lega de datele dvs. pentru a apărea dinamic pe chitanța finală tipărită sau electronică. Rețineți că imaginile colorate nu pot fi tipărite pe imprimante termice.',
          it: 'Puoi aggiungere una foto personalizzata al tuo modello di ricevuta, che verrà stampata esattamente come caricata, oppure puoi collegarla ai tuoi dati per farla apparire dinamicamente nella ricevuta finale stampata o elettronica. Si prega di notare che le immagini a colori non possono essere stampate su stampanti termiche.',
          zh_cn:
            '您可以将自定义照片添加到您的收据模板中，该照片将按上传的方式准确打印，或者您可以将其链接到您的数据，以便在最终的打印或电子收据中动态显示。请注意，彩色图像无法在热敏打印机上打印。',
          hi: 'आप अपनी रसीद टेम्पलेट में एक कस्टम फोटो जोड़ सकते हैं, जिसे ठीक उसी तरह प्रिंट किया जाएगा जैसा अपलोड किया गया है, या आप इसे अपने डेटा से लिंक कर सकते हैं ताकि यह अंतिम मुद्रित या ई-रसीद में गतिशील रूप से दिखाई दे। कृपया ध्यान दें कि रंगीन छवियां थर्मल प्रिंटर पर मुद्रित नहीं की जा सकती हैं。',
          ar: 'يمكنك إضافة صورة مخصصة إلى قالب الإيصال الخاص بك، والتي ستتم طباعتها تمامًا كما تم تحميلها، أو يمكنك ربطها ببياناتك لتظهر ديناميكيًا في الإيصال النهائي المطبوع أو الإلكتروني. يرجى ملاحظة أنه لا يمكن طباعة الصور الملونة على الطابعات الحرارية.',
          bn: 'আপনি আপনার রসিদের টেমপ্লেটে একটি কাস্টম ফটো যোগ করতে পারেন, যা ঠিক যেমনটি আপলোড করা হয়েছে তেমন মুদ্রিত হবে, বা আপনি এটি আপনার ডেটার সাথে সংযুক্ত করতে পারেন যাতে এটি চূড়ান্ত মুদ্রিত বা ই-রসিদে গতিশীলভাবে প্রদর্শিত হয়। দয়া করে মনে রাখবেন যে রঙিন ছবি থার্মাল প্রিন্টারে মুদ্রণ করা যাবে না।',
          ru: 'Вы можете добавить собственное фото в шаблон квитанции, которое будет напечатано точно так, как загружено, или вы можете связать его с вашими данными, чтобы оно динамически отображалось в итоговой печатной или электронной квитанции. Обратите внимание, что цветные изображения нельзя печатать на термопринтерах.',
          ja: 'レシートテンプレートにカスタム写真を追加することができ、アップロードされたままの状態で正確に印刷されるか、データにリンクして最終的な印刷または電子レシートに動的に表示することができます。カラフルな画像はサーマルプリンタで印刷できないことにご注意ください。',
          tr: 'Makbuz şablonunuza, yüklendiği gibi tam olarak yazdırılacak özel bir fotoğraf ekleyebilir veya verilerinize bağlayarak nihai basılı veya e-makbuzda dinamik olarak görünmesini sağlayabilirsiniz. Renkli resimlerin termal yazıcılarda yazdırılamayacağını unutmayın.',
          ko: '영수증 템플릿에 사용자 지정 사진을 추가할 수 있으며 업로드된 그대로 인쇄되거나 데이터를 연결하여 최종 인쇄물 또는 전자 영수증에 동적으로 표시될 수 있습니다. 컬러 이미지는 열 프린터에서 인쇄할 수 없음을 유의하세요.',
          vi: 'Bạn có thể thêm ảnh tùy chỉnh vào mẫu biên nhận của mình, sẽ được in chính xác như đã tải lên hoặc bạn có thể liên kết nó với dữ liệu của mình để xuất hiện động trên biên nhận in hoặc điện tử cuối cùng. Lưu ý rằng hình ảnh màu không thể in trên máy in nhiệt.',
          id: 'Anda dapat menambahkan foto khusus ke template tanda terima Anda, yang akan dicetak persis seperti yang diunggah, atau Anda dapat menghubungkannya ke data Anda untuk muncul secara dinamis pada tanda terima cetak atau elektronik akhir. Perhatikan bahwa gambar berwarna tidak dapat dicetak pada printer termal.',
          th: 'คุณสามารถเพิ่มรูปภาพที่กำหนดเองลงในเทมเพลตรับของคุณ ซึ่งจะพิมพ์ออกมาเหมือนกับที่อัปโหลด หรือคุณสามารถเชื่อมโยงรูปภาพกับข้อมูลของคุณเพื่อให้แสดงผลแบบไดนามิกบนใบเสร็จที่พิมพ์หรืออิเล็กทรอนิกส์ขั้นสุดท้าย โปรดทราบว่าไม่สามารถพิมพ์ภาพสีบนเครื่องพิมพ์ความร้อนได้。',
          ms: 'Anda boleh menambah foto khusus pada templat resit anda, yang akan dicetak dengan tepat seperti yang dimuat naik, atau anda boleh menghubungkannya dengan data anda untuk dipaparkan secara dinamik pada resit cetakan atau e-resit akhir. Sila ambil perhatian bahawa imej berwarna tidak boleh dicetak pada pencetak terma.',
          ar_eg:
            'يمكنك إضافة صورة مخصصة إلى قالب الإيصال الخاص بك، والتي ستتم طباعتها تمامًا كما تم تحميلها، أو يمكنك ربطها ببياناتك لتظهر ديناميكيًا في الإيصال النهائي المطبوع أو الإلكتروني. يرجى ملاحظة أنه لا يمكن طباعة الصور الملونة على الطابعات الحرارية.',
          uk: "Ви можете додати власне фото до шаблону квитанції, яке буде надруковано точно так, як було завантажено, або ви можете пов'язати його з вашими даними, щоб воно динамічно з'являлося у кінцевому надрукованому або електронному чеку. Зверніть увагу, що кольорові зображення не можна друкувати на термопринтерах.",
        },
      },

      upload_local_image: {
        en: 'Upload Local Image',
        es: 'Subir Imagen Local',
        fr: 'Télécharger une Image Locale',
        de: 'Lokales Bild Hochladen',
        pt: 'Carregar Imagem Local',
        pl: 'Prześlij Lokalny Obraz',
        nl: 'Lokale Afbeelding Uploaden',
        el: 'Ανέβασμα Τοπικής Εικόνας',
        cs: 'Nahrát Lokální Obrázek',
        sv: 'Ladda upp Lokal Bild',
        hu: 'Helyi Kép Feltöltése',
        da: 'Upload Lokal Billede',
        fi: 'Lataa Paikallinen Kuva',
        sk: 'Nahrať Lokálny Obrázok',
        bg: 'Качване на Местно Изображение',
        hr: 'Prenesi Lokalnu Sliku',
        lt: 'Įkelti Vietinį Vaizdą',
        lv: 'Augšupielādēt Vietējo Attēlu',
        et: 'Laadi Kohalik Pilt',
        sl: 'Naloži Lokalno Sliko',
        ga: 'Uaslódáil Íomhá Áitiúil',
        mt: "Ittella' Immaġni Lokali",
        cy: 'Llwytho Delwedd Leol',
        ro: 'Încărcați Imagine Locală',
        it: 'Carica Immagine Locale',
        zh_cn: '上传本地图片',
        hi: 'स्थानीय छवि अपलोड करें',
        ar: 'تحميل صورة محلية',
        bn: 'লোকাল ইমেজ আপলোড করুন',
        ru: 'Загрузить Локальное Изображение',
        ja: 'ローカル画像をアップロード',
        tr: 'Yerel Resim Yükle',
        ko: '로컬 이미지 업로드',
        vi: 'Tải Lên Hình Ảnh Cục Bộ',
        id: 'Unggah Gambar Lokal',
        th: 'อัปโหลดรูปภาพในเครื่อง',
        ms: 'Muat Naik Imej Tempatan',
        ar_eg: 'تحميل صورة محلية',
        uk: 'Завантажити Локальне Зображення',
      },
    },

    styles: {
      setting_title: {
        en: 'Style Setting',
        es: 'Configuración de Estilo',
        fr: 'Paramètres de Style',
        de: 'Stileinstellung',
        pt: 'Configuração de Estilo',
        pl: 'Ustawienia Stylu',
        nl: 'Stijlinstelling',
        el: 'Ρύθμιση Στυλ',
        cs: 'Nastavení Stylu',
        sv: 'Stilinställning',
        hu: 'Stílus Beállítás',
        da: 'Stilindstilling',
        fi: 'Tyylin Asetus',
        sk: 'Nastavenie Štýlu',
        bg: 'Настройки на Стил',
        hr: 'Postavke Stila',
        lt: 'Stiliaus Nustatymai',
        lv: 'Stila Iestatījumi',
        et: 'Stiili Seadistamine',
        sl: 'Nastavitve Sloga',
        ga: 'Socruithe Stíle',
        mt: 'Settings tal-Istil',
        cy: 'Gosodiadau Arddull',
        ro: 'Setări Stil',
        it: 'Impostazioni dello Stile',
        zh_cn: '样式设置',
        hi: 'स्टाइल सेटिंग',
        ar: 'إعدادات النمط',
        bn: 'স্টাইল সেটিং',
        ru: 'Настройки Стиля',
        ja: 'スタイル設定',
        tr: 'Stil Ayarı',
        ko: '스타일 설정',
        vi: 'Cài Đặt Kiểu',
        id: 'Pengaturan Gaya',
        th: 'การตั้งค่าสไตล์',
        ms: 'Tetapan Gaya',
        ar_eg: 'إعدادات النمط',
        uk: 'Налаштування Стилю',
      },

      positions: {
        en: 'Positions',
        es: 'Posiciones',
        fr: 'Positions',
        de: 'Positionen',
        pt: 'Posições',
        pl: 'Pozycje',
        nl: 'Posities',
        el: 'Θέσεις',
        cs: 'Pozice',
        sv: 'Positioner',
        hu: 'Pozíciók',
        da: 'Positioner',
        fi: 'Paikat',
        sk: 'Pozície',
        bg: 'Позиции',
        hr: 'Pozicije',
        lt: 'Pozicijos',
        lv: 'Pozīcijas',
        et: 'Positsioonid',
        sl: 'Pozicije',
        ga: 'Seasaimh',
        mt: 'Pożizzjonijiet',
        cy: 'Swyddi',
        ro: 'Poziții',
        it: 'Posizioni',
        zh_cn: '位置',
        hi: 'स्थितियाँ',
        ar: 'المواقع',
        bn: 'অবস্থান',
        ru: 'Позиции',
        ja: 'ポジション',
        tr: 'Pozisyonlar',
        ko: '위치',
        vi: 'Vị Trí',
        id: 'Posisi',
        th: 'ตำแหน่ง',
        ms: 'Kedudukan',
        ar_eg: 'المواقع',
        uk: 'Позиції',
      },

      corner_radius: {
        en: 'Corner Radius',
        es: 'Radio de Esquina',
        fr: 'Rayon de Coin',
        de: 'Eckenradius',
        pt: 'Raio de Canto',
        pl: 'Promień Rogu',
        nl: 'Hoekradius',
        el: 'Ακτίνα Γωνίας',
        cs: 'Poloměr Rohu',
        sv: 'Hörnradie',
        hu: 'Sarok Sugár',
        da: 'Hjørneradius',
        fi: 'Kulman Säde',
        sk: 'Polomer Rohu',
        bg: 'Радиус на Ъгъла',
        hr: 'Radijus Kuta',
        lt: 'Kampinis Spindulys',
        lv: 'Stūra Rādiuss',
        et: 'Nurgaraadius',
        sl: 'Polmer Kota',
        ga: 'Ga an Choirnéil',
        mt: 'R-Rajjes tal-Kantuniera',
        cy: 'Pelydr y Cornel',
        ro: 'Raza Colțului',
        it: "Raggio dell'Angolo",
        zh_cn: '圆角半径',
        hi: 'कोने का त्रिज्या',
        ar: 'نصف قطر الزاوية',
        bn: 'কোণের ব্যাসার্ধ',
        ru: 'Радиус Угла',
        ja: 'コーナー半径',
        tr: 'Köşe Yarıçapı',
        ko: '모서리 반경',
        vi: 'Bán Kính Góc',
        id: 'Jari-jari Sudut',
        th: 'รัศมีมุม',
        ms: 'Jejari Sudut',
        ar_eg: 'نصف قطر الزاوية',
        uk: 'Радіус Кута',
      },

      rotate_degree: {
        en: 'Rotate Degree',
        es: 'Grado de Rotación',
        fr: 'Degré de Rotation',
        de: 'Drehwinkel',
        pt: 'Grau de Rotação',
        pl: 'Kąt Obracania',
        nl: 'Rotatiehoek',
        el: 'Μοίρες Περιστροφής',
        cs: 'Úhel Rotace',
        sv: 'Rotationsgrad',
        hu: 'Forgatási Fok',
        da: 'Rotationsgrad',
        fi: 'Kiertokulma',
        sk: 'Uhol Otočenia',
        bg: 'Градус на Завъртане',
        hr: 'Kut Rotacije',
        lt: 'Pasukimo Kampas',
        lv: 'Rotācijas Grāds',
        et: 'Pööramise Kraad',
        sl: 'Stopinja Vrtenja',
        ga: 'Céim Rothlaithe',
        mt: "Grad ta' Rotazzjoni",
        cy: 'Gradd Troi',
        ro: 'Grad de Rotire',
        it: 'Grado di Rotazione',
        zh_cn: '旋转角度',
        hi: 'घुमाव डिग्री',
        ar: 'زاوية الدوران',
        bn: 'ঘূর্ণন ডিগ্রি',
        ru: 'Угол Поворота',
        ja: '回転角度',
        tr: 'Döndürme Derecesi',
        ko: '회전 각도',
        vi: 'Góc Xoay',
        id: 'Derajat Rotasi',
        th: 'องศาการหมุน',
        ms: 'Darjah Putaran',
        ar_eg: 'زاوية الدوران',
        uk: 'Кут Повороту',
      },

      dimensions: {
        en: 'Dimensions',
        es: 'Dimensiones',
        fr: 'Dimensions',
        de: 'Abmessungen',
        pt: 'Dimensões',
        pl: 'Wymiary',
        nl: 'Afmetingen',
        el: 'Διαστάσεις',
        cs: 'Rozměry',
        sv: 'Mått',
        hu: 'Méretek',
        da: 'Dimensioner',
        fi: 'Mitat',
        sk: 'Rozmery',
        bg: 'Размери',
        hr: 'Dimenzije',
        lt: 'Matmenys',
        lv: 'Izmēri',
        et: 'Mõõtmed',
        sl: 'Dimenzije',
        ga: 'Toisí',
        mt: 'Dimensjonijiet',
        cy: 'Dimensiynau',
        ro: 'Dimensiuni',
        it: 'Dimensioni',
        zh_cn: '尺寸',
        hi: 'आयाम',
        ar: 'الأبعاد',
        bn: 'মাত্রা',
        ru: 'Размеры',
        ja: '寸法',
        tr: 'Boyutlar',
        ko: '치수',
        vi: 'Kích Thước',
        id: 'Dimensi',
        th: 'ขนาด',
        ms: 'Dimensi',
        ar_eg: 'الأبعاد',
        uk: 'Розміри',
      },

      customise_text: {
        en: 'Customise Text',
        es: 'Personalizar Texto',
        fr: 'Personnaliser le Texte',
        de: 'Text Anpassen',
        pt: 'Personalizar Texto',
        pl: 'Dostosuj Tekst',
        nl: 'Tekst Aanpassen',
        el: 'Προσαρμογή Κειμένου',
        cs: 'Přizpůsobit Text',
        sv: 'Anpassa Text',
        hu: 'Testreszabás Szöveg',
        da: 'Tilpas Tekst',
        fi: 'Muokkaa Tekstiä',
        sk: 'Prispôsobiť Text',
        bg: 'Персонализиране на Текста',
        hr: 'Prilagodite Tekst',
        lt: 'Pritaikyti Tekstą',
        lv: 'Pielāgot Tekstu',
        et: 'Kohanda Teksti',
        sl: 'Prilagodi Besedilo',
        ga: 'Saincheap Téacs',
        mt: 'Ippersonalizza t-Test',
        cy: 'Addasu Testun',
        ro: 'Personalizați Textul',
        it: 'Personalizza Testo',
        zh_cn: '自定义文本',
        hi: 'पाठ अनुकूलित करें',
        ar: 'تخصيص النص',
        bn: 'টেক্সট কাস্টমাইজ করুন',
        ru: 'Настроить Текст',
        ja: 'テキストをカスタマイズ',
        tr: 'Metni Özelleştir',
        ko: '텍스트 사용자 정의',
        vi: 'Tùy Chỉnh Văn Bản',
        id: 'Sesuaikan Teks',
        th: 'ปรับแต่งข้อความ',
        ms: 'Sesuaikan Teks',
        ar_eg: 'تخصيص النص',
        uk: 'Налаштувати Текст',
      },

      pre_set_text_styles: {
        en: 'Pre-set Text Styles',
        es: 'Estilos de Texto Predefinidos',
        fr: 'Styles de Texte Prédéfinis',
        de: 'Voreingestellte Textstile',
        pt: 'Estilos de Texto Pré-definidos',
        pl: 'Wstępnie Ustawione Style Tekstu',
        nl: 'Vooraf ingestelde Tekststijlen',
        el: 'Προκαθορισμένα Στυλ Κειμένου',
        cs: 'Přednastavené Styly Textu',
        sv: 'Förinställda Textstilar',
        hu: 'Előre Beállított Szövegstílusok',
        da: 'Forudindstillede Tekststilarter',
        fi: 'Esiasetetut Tekstityylit',
        sk: 'Prednastavené Štýly Textu',
        bg: 'Предварително Зададени Стилове Текста',
        hr: 'Unaprijed Postavljeni Stilovi Teksta',
        lt: 'Iš Anksto Nustatyti Teksto Stiliai',
        lv: 'Iepriekš Iestatītie Teksta Stili',
        et: 'Eelseadistatud Tekstistiilid',
        sl: 'Vnaprej Nastavljeni Slogi Besedila',
        ga: 'Stíleanna Téacs Réamhshocraithe',
        mt: 'Stili tat-Test Miftuħa minn Qabel',
        cy: 'Arddulliau Testun Rhagosodedig',
        ro: 'Stiluri de Text Prestabilite',
        it: 'Stili di Testo Preimpostati',
        zh_cn: '预设文本样式',
        hi: 'पूर्व-सेट टेक्स्ट शैलियाँ',
        ar: 'أنماط النص المحددة مسبقًا',
        bn: 'প্রি-সেট টেক্সট স্টাইল',
        ru: 'Предустановленные Стили Текста',
        ja: '事前設定されたテキストスタイル',
        tr: 'Ön Ayarlı Metin Stilleri',
        ko: '사전 설정된 텍스트 스타일',
        vi: 'Kiểu Văn Bản Đặt Trước',
        id: 'Gaya Teks yang Telah Ditetapkan',
        th: 'สไตล์ข้อความที่ตั้งไว้ล่วงหน้า',
        ms: 'Gaya Teks Pratetap',
        ar_eg: 'أنماط النص المحددة مسبقًا',
        uk: 'Попередньо Встановлені Стилі Тексту',
      },

      select_shape_colour: {
        en: 'Select Shape Colour',
        es: 'Seleccionar Color de Forma',
        fr: 'Sélectionner la Couleur de la Forme',
        de: 'Formfarbe Wählen',
        pt: 'Selecionar Cor da Forma',
        pl: 'Wybierz Kolor Kształtu',
        nl: 'Vormkleur Kiezen',
        el: 'Επιλέξτε Χρώμα Σχήματος',
        cs: 'Vyberte Barvu Tvaru',
        sv: 'Välj Formfärg',
        hu: 'Válassza ki az Alak Színét',
        da: 'Vælg Formfarve',
        fi: 'Valitse Muodon Väri',
        sk: 'Vyberte Farbu Tvaru',
        bg: 'Изберете Цвят на Форма',
        hr: 'Odaberite Boju Oblika',
        lt: 'Pasirinkite Formos Spalvą',
        lv: 'Izvēlieties Formas Krāsu',
        et: 'Vali Kujundi Värv',
        sl: 'Izberite Barvo Oblike',
        ga: 'Roghnaigh Dath Cruth',
        mt: 'Agħżel Kulur tal-Forma',
        cy: 'Dewiswch Lliw Siâp',
        ro: 'Selectați Culoarea Formei',
        it: 'Seleziona Colore della Forma',
        zh_cn: '选择形状颜色',
        hi: 'आकार का रंग चुनें',
        ar: 'اختر لون الشكل',
        bn: 'আকৃতির রঙ নির্বাচন করুন',
        ru: 'Выберите Цвет Фигуры',
        ja: '図形の色を選択',
        tr: 'Şekil Rengini Seç',
        ko: '도형 색상 선택',
        vi: 'Chọn Màu Hình Dạng',
        id: 'Pilih Warna Bentuk',
        th: 'เลือกสีของรูปร่าง',
        ms: 'Pilih Warna Bentuk',
        ar_eg: 'اختر لون الشكل',
        uk: 'Виберіть Колір Фігури',
      },
    },
  },

  entity: {
    layers: {
      receipt_header: {
        en: 'Receipt Header',
        es: 'Encabezado del Recibo',
        fr: 'En-tête du Reçu',
        de: 'Belegkopf',
        pt: 'Cabeçalho do Recibo',
        pl: 'Nagłówek Paragonu',
        nl: 'Bonkop',
        el: 'Κεφαλίδα Απόδειξης',
        cs: 'Hlavička Účtenky',
        sv: 'Kvittorubrik',
        hu: 'Nyugta Fejléc',
        da: 'Kvitteringshoved',
        fi: 'Kuitin Otsikko',
        sk: 'Hlavička Príjmového Dokladu',
        bg: 'Заглавие на Разписка',
        hr: 'Zaglavlje Računa',
        lt: 'Kvitų Antraštė',
        lv: 'Kvīts Galvene',
        et: 'Kviitungi Päis',
        sl: 'Glava Računa',
        ga: 'Ceanntásc Admhála',
        mt: 'Intestatura tar-Riċevuta',
        cy: 'Pennawd Derbynneb',
        ro: 'Antetul Chitanței',
        it: 'Intestazione Ricevuta',
        zh_cn: '收据标题',
        hi: 'रसीद हेडर',
        ar: 'رأس الإيصال',
        bn: 'রসিদের শিরোনাম',
        ru: 'Заголовок Квитанции',
        ja: '領収書ヘッダー',
        tr: 'Makbuz Başlığı',
        ko: '영수증 헤더',
        vi: 'Tiêu Đề Biên Nhận',
        id: 'Header Kwitansi',
        th: 'ส่วนหัวของใบเสร็จ',
        ms: 'Pengepala Resit',
        ar_eg: 'رأس الإيصال',
        uk: 'Заголовок Квитанції',
      },
      receipt_column_titles: {
        en: 'Receipt Column Titles',
        es: 'Títulos de Columnas del Recibo',
        fr: 'Titres des Colonnes du Reçu',
        de: 'Spaltentitel des Belegs',
        pt: 'Títulos das Colunas do Recibo',
        pl: 'Tytuły Kolumn Paragonu',
        nl: 'Bon Kolomtitels',
        el: 'Τίτλοι Στηλών Απόδειξης',
        cs: 'Názvy Sloupců Účtenky',
        sv: 'Kolumnrubriker för Kvitto',
        hu: 'Nyugta Oszlop Címek',
        da: 'Kvitteringskolonnetitler',
        fi: 'Kuitin Sarakeotsikot',
        sk: 'Názvy Stĺpcov Príjmového Dokladu',
        bg: 'Заглавия на Колони на Разписката',
        hr: 'Naslovi Stupaca Računa',
        lt: 'Kvitų Stulpelių Pavadinimai',
        lv: 'Kvīts Kolonnu Nosaukumi',
        et: 'Kviitungi Veerupealkirjad',
        sl: 'Naslovi Stolpcev Računa',
        ga: 'Teidil Colúin Admhála',
        mt: 'Titoli tal-Kolonni tar-Riċevuta',
        cy: 'Teitlau Colofn Derbynneb',
        ro: 'Titluri de Coloană ale Chitanței',
        it: 'Titoli delle Colonne della Ricevuta',
        zh_cn: '收据列标题',
        hi: 'रसीद कॉलम शीर्षक',
        ar: 'عناوين أعمدة الإيصال',
        bn: 'রসিদের কলামের শিরোনাম',
        ru: 'Заголовки Столбцов Квитанции',
        ja: '領収書列タイトル',
        tr: 'Makbuz Sütun Başlıkları',
        ko: '영수증 열 제목',
        vi: 'Tiêu Đề Cột Biên Nhận',
        id: 'Judul Kolom Kwitansi',
        th: 'ชื่อคอลัมน์ใบเสร็จ',
        ms: 'Tajuk Lajur Resit',
        ar_eg: 'عناوين أعمدة الإيصال',
        uk: 'Заголовки Стовпців Квитанції',
      },

      receipt_body: {
        en: 'Receipt Body',
        es: 'Cuerpo del Recibo',
        fr: 'Corps du Reçu',
        de: 'Belegkörper',
        pt: 'Corpo do Recibo',
        pl: 'Treść Paragonu',
        nl: 'Bon Inhoud',
        el: 'Σώμα Απόδειξης',
        cs: 'Tělo Účtenky',
        sv: 'Kvittoinnehåll',
        hu: 'Nyugta Törzs',
        da: 'Kvitteringsindhold',
        fi: 'Kuitin Runko',
        sk: 'Telo Príjmového Dokladu',
        bg: 'Съдържание на Разписката',
        hr: 'Tijelo Računa',
        lt: 'Kvitų Turinys',
        lv: 'Kvīts Saturs',
        et: 'Kviitungi Sisu',
        sl: 'Telo Računa',
        ga: 'Corp Admhála',
        mt: 'Korp tar-Riċevuta',
        cy: 'Corff Derbynneb',
        ro: 'Corpul Chitanței',
        it: 'Corpo della Ricevuta',
        zh_cn: '收据主体',
        hi: 'रसीद बॉडी',
        ar: 'جسم الإيصال',
        bn: 'রসিদের মূল অংশ',
        ru: 'Тело Квитанции',
        ja: '領収書本文',
        tr: 'Makbuz Gövdesi',
        ko: '영수증 본문',
        vi: 'Nội Dung Biên Nhận',
        id: 'Isi Kwitansi',
        th: 'เนื้อหาใบเสร็จ',
        ms: 'Badan Resit',
        ar_eg: 'جسم الإيصال',
        uk: 'Основна Частина Квитанції',
      },

      payment_summary: {
        en: 'Payment Summary',
        es: 'Resumen de Pago',
        fr: 'Résumé de Paiement',
        de: 'Zahlungsübersicht',
        pt: 'Resumo de Pagamento',
        pl: 'Podsumowanie Płatności',
        nl: 'Betalingssamenvatting',
        el: 'Σύνοψη Πληρωμής',
        cs: 'Souhrn Platby',
        sv: 'Betalningssammanfattning',
        hu: 'Fizetési Összegzés',
        da: 'Betalingsoversigt',
        fi: 'Maksun Yhteenveto',
        sk: 'Súhrn Platby',
        bg: 'Обобщение на Плащането',
        hr: 'Sažetak Plaćanja',
        lt: 'Mokėjimo Santrauka',
        lv: 'Maksājuma Kopsavilkums',
        et: 'Makse Kokkuvõte',
        sl: 'Povzetek Plačila',
        ga: 'Achoimre Íocaíochta',
        mt: 'Sommarju tal-Ħlas',
        cy: 'Crynodeb Taliad',
        ro: 'Rezumatul Plății',
        it: 'Riepilogo Pagamento',
        zh_cn: '付款摘要',
        hi: 'भुगतान सारांश',
        ar: 'ملخص الدفع',
        bn: 'পেমেন্ট সারাংশ',
        ru: 'Сводка по Платежу',
        ja: '支払い概要',
        tr: 'Ödeme Özeti',
        ko: '결제 요약',
        vi: 'Tóm Tắt Thanh Toán',
        id: 'Ringkasan Pembayaran',
        th: 'สรุปการชำระเงิน',
        ms: 'Ringkasan Pembayaran',
        ar_eg: 'ملخص الدفع',
        uk: 'Підсумок Платежу',
      },

      footer: {
        en: 'Footer',
        es: 'Pie de Página',
        fr: 'Pied de Page',
        de: 'Fußzeile',
        pt: 'Rodapé',
        pl: 'Stopka',
        nl: 'Voettekst',
        el: 'Υποσέλιδο',
        cs: 'Patička',
        sv: 'Sidfot',
        hu: 'Lábléc',
        da: 'Sidefod',
        fi: 'Alatunniste',
        sk: 'Päta',
        bg: 'Долен Колонтитул',
        hr: 'Podnožje',
        lt: 'Poraštis',
        lv: 'Kājene',
        et: 'Jalus',
        sl: 'Noga',
        ga: 'Buntásc',
        mt: 'Footer',
        cy: 'Troedyn',
        ro: 'Subsol',
        it: 'Piè di Pagina',
        zh_cn: '页脚',
        hi: 'पाद लेख',
        ar: 'تذييل',
        bn: 'ফুটার',
        ru: 'Нижний Колонтитул',
        ja: 'フッター',
        tr: 'Altbilgi',
        ko: '바닥글',
        vi: 'Chân Trang',
        id: 'Footer',
        th: 'ส่วนท้าย',
        ms: 'Footer',
        ar_eg: 'تذييل',
        uk: 'Нижній Колонтитул',
      },
    },
  },

  digital_menu: {
    set_screen_background: {
      en: 'Set Screen Background',
      es: 'Establecer Fondo de Pantalla',
      fr: 'Définir l’Arrière-plan de l’Écran',
      de: 'Bildschirmhintergrund Festlegen',
      pt: 'Definir Fundo da Tela',
      pl: 'Ustaw Tło Ekranu',
      nl: 'Stel Schermachtergrond In',
      el: 'Ορίστε Φόντο Οθόνης',
      cs: 'Nastavit Pozadí Obrazovky',
      sv: 'Ställ in Skärmbakgrund',
      hu: 'Képernyő Háttér Beállítása',
      da: 'Indstil Skærmbaggrund',
      fi: 'Aseta Näytön Tausta',
      sk: 'Nastaviť Pozadie Obrazovky',
      bg: 'Задаване на Фон на Екрана',
      hr: 'Postavi Pozadinu Zaslona',
      lt: 'Nustatyti Ekrano Foną',
      lv: 'Iestatīt Ekrāna Fonā',
      et: 'Määra Ekraani Taust',
      sl: 'Nastavi Ozadje Zaslona',
      ga: 'Socraigh Cúlra an Scáileáin',
      mt: 'Issettja Sfond tal-Iskrin',
      cy: 'Gosod Cefndir y Sgrin',
      ro: 'Setează Fundalul Ecranului',
      it: 'Imposta Sfondo Schermo',
      zh_cn: '设置屏幕背景',
      hi: 'स्क्रीन पृष्ठभूमि सेट करें',
      ar: 'تعيين خلفية الشاشة',
      bn: 'স্ক্রিন ব্যাকগ্রাউন্ড সেট করুন',
      ru: 'Установить Фон Экрана',
      ja: '画面の背景を設定',
      tr: 'Ekran Arka Planını Ayarla',
      ko: '화면 배경 설정',
      vi: 'Đặt Nền Màn Hình',
      id: 'Atur Latar Belakang Layar',
      th: 'ตั้งค่าพื้นหลังหน้าจอ',
      ms: 'Tetapkan Latar Belakang Skrin',
      ar_eg: 'تعيين خلفية الشاشة',
      uk: 'Встановити Фон Екрана',
    },

    select_background_colour: {
      en: 'Select Background Colour',
      es: 'Seleccionar Color de Fondo',
      fr: 'Sélectionner la Couleur d’Arrière-plan',
      de: 'Hintergrundfarbe Auswählen',
      pt: 'Selecionar Cor de Fundo',
      pl: 'Wybierz Kolor Tła',
      nl: 'Selecteer Achtergrondkleur',
      el: 'Επιλέξτε Χρώμα Φόντου',
      cs: 'Vyberte Barvu Pozadí',
      sv: 'Välj Bakgrundsfärg',
      hu: 'Válasszon Háttérszínt',
      da: 'Vælg Baggrundsfarve',
      fi: 'Valitse Taustaväri',
      sk: 'Vyberte Farbu Pozadia',
      bg: 'Изберете Цвят на Фона',
      hr: 'Odaberite Boju Pozadine',
      lt: 'Pasirinkite Fono Spalvą',
      lv: 'Izvēlieties Fona Krāsu',
      et: 'Valige Taustavärv',
      sl: 'Izberite Barvo Ozadja',
      ga: 'Roghnaigh Dath Cúlra',
      mt: 'Agħżel il-Kulur tal-Isfond',
      cy: 'Dewiswch Liw Cefndir',
      ro: 'Selectați Culoarea Fundalului',
      it: 'Seleziona Colore di Sfondo',
      zh_cn: '选择背景颜色',
      hi: 'पृष्ठभूमि का रंग चुनें',
      ar: 'اختر لون الخلفية',
      bn: 'পটভূমির রঙ নির্বাচন করুন',
      ru: 'Выберите Цвет Фона',
      ja: '背景色を選択',
      tr: 'Arka Plan Rengini Seç',
      ko: '배경색 선택',
      vi: 'Chọn Màu Nền',
      id: 'Pilih Warna Latar Belakang',
      th: 'เลือกสีพื้นหลัง',
      ms: 'Pilih Warna Latar Belakang',
      ar_eg: 'اختر لون الخلفية',
      uk: 'Виберіть Колір Фону',
    },

    upload_background_image: {
      en: 'Upload Background Image',
      es: 'Subir Imagen de Fondo',
      fr: 'Téléverser l’Image d’Arrière-plan',
      de: 'Hintergrundbild Hochladen',
      pt: 'Enviar Imagem de Fundo',
      pl: 'Prześlij Obraz Tła',
      nl: 'Achtergrondafbeelding Uploaden',
      el: 'Ανεβάστε Εικόνα Φόντου',
      cs: 'Nahrát Obrázek Pozadí',
      sv: 'Ladda upp Bakgrundsbild',
      hu: 'Háttérképet Feltölteni',
      da: 'Upload Baggrundsbillede',
      fi: 'Lataa Taustakuva',
      sk: 'Nahrať Obrázok Pozadia',
      bg: 'Качване на Фоново Изображение',
      hr: 'Učitaj Pozadinsku Sliku',
      lt: 'Įkelti Fono Paveikslėlį',
      lv: 'Augšupielādēt Fona Attēlu',
      et: 'Laadi Üles Taustapilt',
      sl: 'Naloži Sliko za Ozadje',
      ga: 'Uaslódáil Íomhá Cúlra',
      mt: 'Itella’ Immaġni tal-Isfond',
      cy: 'Llwytho Delwedd Cefndir i Fyny',
      ro: 'Încărcați Imagine de Fundal',
      it: 'Carica Immagine di Sfondo',
      zh_cn: '上传背景图像',
      hi: 'पृष्ठभूमि छवि अपलोड करें',
      ar: 'تحميل صورة الخلفية',
      bn: 'পটভূমির ছবি আপলোড করুন',
      ru: 'Загрузить Фоновое Изображение',
      ja: '背景画像をアップロード',
      tr: 'Arka Plan Görseli Yükle',
      ko: '배경 이미지 업로드',
      vi: 'Tải Lên Hình Nền',
      id: 'Unggah Gambar Latar Belakang',
      th: 'อัปโหลดภาพพื้นหลัง',
      ms: 'Muat Naik Imej Latar Belakang',
      ar_eg: 'تحميل صورة الخلفية',
      uk: 'Завантажити Фонове Зображення',
    },

    layers: {
      en: 'Layers',
      es: 'Capas',
      fr: 'Calques',
      de: 'Ebenen',
      pt: 'Camadas',
      pl: 'Warstwy',
      nl: 'Lagen',
      el: 'Στρώματα',
      cs: 'Vrstvy',
      sv: 'Lager',
      hu: 'Rétegek',
      da: 'Lag',
      fi: 'Tasot',
      sk: 'Vrstvy',
      bg: 'Слоеве',
      hr: 'Slojevi',
      lt: 'Sluoksniai',
      lv: 'Slāņi',
      et: 'Kihid',
      sl: 'Plasti',
      ga: 'Sraitheanna',
      mt: 'Saffi',
      cy: 'Haenau',
      ro: 'Straturi',
      it: 'Livelli',
      zh_cn: '图层',
      hi: 'परतें',
      ar: 'طبقات',
      bn: 'স্তরসমূহ',
      ru: 'Слои',
      ja: 'レイヤー',
      tr: 'Katmanlar',
      ko: '레이어',
      vi: 'Lớp',
      id: 'Lapisan',
      th: 'เลเยอร์',
      ms: 'Lapisan',
      ar_eg: 'طبقات',
      uk: 'Шари',
    },

    screen_settings: {
      en: 'Screen Settings',
      es: 'Configuración de Pantalla',
      fr: 'Paramètres de l’Écran',
      de: 'Bildschirmeinstellungen',
      pt: 'Configurações da Tela',
      pl: 'Ustawienia Ekranu',
      nl: 'Scherminstellingen',
      el: 'Ρυθμίσεις Οθόνης',
      cs: 'Nastavení Obrazovky',
      sv: 'Skärminställningar',
      hu: 'Képernyő Beállítások',
      da: 'Skærmindstillinger',
      fi: 'Näytön Asetukset',
      sk: 'Nastavenia Obrazovky',
      bg: 'Настройки на Екрана',
      hr: 'Postavke Zaslona',
      lt: 'Ekrano Nustatymai',
      lv: 'Ekrāna Iestatījumi',
      et: 'Ekraani Seaded',
      sl: 'Nastavitve Zaslona',
      ga: 'Socruithe Scáileáin',
      mt: 'Settings tal-Iskrin',
      cy: 'Gosodiadau Sgrin',
      ro: 'Setări Ecran',
      it: 'Impostazioni Schermo',
      zh_cn: '屏幕设置',
      hi: 'स्क्रीन सेटिंग्स',
      ar: 'إعدادات الشاشة',
      bn: 'স্ক্রিন সেটিংস',
      ru: 'Настройки Экрана',
      ja: '画面設定',
      tr: 'Ekran Ayarları',
      ko: '화면 설정',
      vi: 'Cài Đặt Màn Hình',
      id: 'Pengaturan Layar',
      th: 'การตั้งค่าหน้าจอ',
      ms: 'Tetapan Skrin',
      ar_eg: 'إعدادات الشاشة',
      uk: 'Налаштування Екрана',
    },

    empty_layer: {
      title: {
        en: 'No layer has been added',
        es: 'No se ha añadido ninguna capa',
        fr: 'Aucun calque n’a été ajouté',
        de: 'Es wurde keine Ebene hinzugefügt',
        pt: 'Nenhuma camada foi adicionada',
        pl: 'Nie dodano żadnej warstwy',
        nl: 'Er is geen laag toegevoegd',
        el: 'Δεν έχει προστεθεί κανένα στρώμα',
        cs: 'Nebyla přidána žádná vrstva',
        sv: 'Inget lager har lagts till',
        hu: 'Nem lett hozzáadva réteg',
        da: 'Ingen lag er blevet tilføjet',
        fi: 'Yhtään kerrosta ei ole lisätty',
        sk: 'Nebola pridaná žiadna vrstva',
        bg: 'Не е добавен нито един слой',
        hr: 'Nije dodan nijedan sloj',
        lt: 'Nėra pridėta jokio sluoksnio',
        lv: 'Nav pievienots neviens slānis',
        et: 'Ühtegi kihti pole lisatud',
        sl: 'Ni bil dodan noben sloj',
        ga: 'Níor cuireadh aon sraith leis',
        mt: 'Ebda saff ġie miżjud',
        cy: 'Ni chafodd unrhyw haen ei hychwanegu',
        ro: 'Nu a fost adăugat niciun strat',
        it: 'Nessun livello è stato aggiunto',
        zh_cn: '未添加任何图层',
        hi: 'कोई लेयर नहीं जोड़ी गई',
        ar: 'لم تتم إضافة أي طبقة',
        bn: 'কোনও স্তর যোগ করা হয়নি',
        ru: 'Ни один слой не был добавлен',
        ja: 'レイヤーが追加されていません',
        tr: 'Hiçbir katman eklenmedi',
        ko: '레이어가 추가되지 않았습니다',
        vi: 'Chưa có lớp nào được thêm',
        id: 'Belum ada lapisan yang ditambahkan',
        th: 'ยังไม่ได้เพิ่มเลเยอร์',
        ms: 'Tiada lapisan telah ditambah',
        ar_eg: 'لم تتم إضافة أي طبقة',
        uk: 'Жодного шару не додано',
      },
      description: {
        en: 'Begin by adding items from the toolbar',
        es: 'Comienza agregando elementos desde la barra de herramientas',
        fr: 'Commencez par ajouter des éléments depuis la barre d’outils',
        de: 'Beginnen Sie, indem Sie Elemente aus der Symbolleiste hinzufügen',
        pt: 'Comece adicionando itens da barra de ferramentas',
        pl: 'Zacznij od dodania elementów z paska narzędzi',
        nl: 'Begin met het toevoegen van items vanuit de werkbalk',
        el: 'Ξεκινήστε προσθέτοντας αντικείμενα από τη γραμμή εργαλείων',
        cs: 'Začněte přidáním položek z panelu nástrojů',
        sv: 'Börja med att lägga till objekt från verktygsfältet',
        hu: 'Kezdje elemek hozzáadásával az eszköztárról',
        da: 'Begynd med at tilføje elementer fra værktøjslinjen',
        fi: 'Aloita lisäämällä kohteita työkalupalkista',
        sk: 'Začnite pridaním položiek z panela nástrojov',
        bg: 'Започнете, като добавите елементи от лентата с инструменти',
        hr: 'Započnite dodavanjem stavki s alatne trake',
        lt: 'Pradėkite pridėdami elementus iš įrankių juostos',
        lv: 'Sāciet, pievienojot vienumus no rīkjoslas',
        et: 'Alustage elementide lisamisest tööriistaribalt',
        sl: 'Začnite z dodajanjem elementov iz orodne vrstice',
        ga: 'Tosaigh trí mhíreanna a chur leis ón mbarra uirlisí',
        mt: 'Ibda billi żżid oġġetti mit-toolbar',
        cy: "Dechreuwch trwy ychwanegu eitemau o'r bar offer",
        ro: 'Începeți prin a adăuga elemente din bara de instrumente',
        it: 'Inizia aggiungendo elementi dalla barra degli strumenti',
        zh_cn: '首先从工具栏添加项目',
        hi: 'टूलबार से आइटम जोड़कर शुरू करें',
        ar: 'ابدأ بإضافة عناصر من شريط الأدوات',
        bn: 'টুলবার থেকে আইটেম যোগ করে শুরু করুন',
        ru: 'Начните с добавления элементов с панели инструментов',
        ja: 'ツールバーから項目を追加して開始します',
        tr: 'Araç çubuğundan öğeler ekleyerek başlayın',
        ko: '도구 모음에서 항목을 추가하여 시작하세요',
        vi: 'Bắt đầu bằng cách thêm mục từ thanh công cụ',
        id: 'Mulailah dengan menambahkan item dari bilah alat',
        th: 'เริ่มต้นโดยการเพิ่มรายการจากแถบเครื่องมือ',
        ms: 'Mulakan dengan menambah item dari bar alat',
        ar_eg: 'ابدأ بإضافة عناصر من شريط الأدوات',
        uk: 'Почніть з додавання елементів з панелі інструментів',
      },
    },
  },

  item_availability_link: {
    en: 'Item Availability Link',
    es: 'Enlace de Disponibilidad de Artículo',
    fr: 'Lien de Disponibilité de l’Article',
    de: 'Artikelverfügbarkeitslink',
    pt: 'Link de Disponibilidade do Item',
    pl: 'Link Dostępności Produktu',
    nl: 'Koppeling voor Artikelbeschikbaarheid',
    el: 'Σύνδεσμος Διαθεσιμότητας Αντικειμένου',
    cs: 'Odkaz na Dostupnost Položky',
    sv: 'Länk för Artikel Tillgänglighet',
    hu: 'Cikk Elérhetőségi Link',
    da: 'Link til Varetilgængelighed',
    fi: 'Tuotteen Saatavuuslinkki',
    sk: 'Odkaz na Dostupnosť Položky',
    bg: 'Връзка за Наличност на Артикул',
    hr: 'Poveznica za Dostupnost Artikla',
    lt: 'Prekės Prieinamumo Nuoroda',
    lv: 'Preces Pieejamības Saite',
    et: 'Toote Saadavuse Link',
    sl: 'Povezava do Razpoložljivosti Artikla',
    ga: 'Nasc Infhaighteachta Míre',
    mt: 'Link tal-Disponibbiltà tal-Oġġett',
    cy: 'Dolen Argaeledd Eitem',
    ro: 'Link de Disponibilitate Articol',
    it: 'Link di Disponibilità dell’Articolo',
    zh_cn: '商品可用性链接',
    hi: 'आइटम उपलब्धता लिंक',
    ar: 'رابط توافر العنصر',
    bn: 'আইটেমের প্রাপ্যতা লিঙ্ক',
    ru: 'Ссылка на Доступность Товара',
    ja: 'アイテム在庫リンク',
    tr: 'Ürün Kullanılabilirlik Bağlantısı',
    ko: '상품 재고 링크',
    vi: 'Liên Kết Tình Trạng Sẵn Có của Mặt Hàng',
    id: 'Tautan Ketersediaan Item',
    th: 'ลิงก์ความพร้อมใช้งานของสินค้า',
    ms: 'Pautan Ketersediaan Item',
    ar_eg: 'رابط توافر العنصر',
    uk: 'Посилання на Наявність Товару',
  },

  item_price_link: {
    en: 'Item Price Link',
    es: 'Enlace de Precio del Artículo',
    fr: 'Lien de Prix de l’Article',
    de: 'Artikelpreis-Link',
    pt: 'Link de Preço do Item',
    pl: 'Link Ceny Produktu',
    nl: 'Koppeling naar Artikelprijs',
    el: 'Σύνδεσμος Τιμής Αντικειμένου',
    cs: 'Odkaz na Cenu Položky',
    sv: 'Länk till Artikelpris',
    hu: 'Tétel Ár Link',
    da: 'Link til Varepris',
    fi: 'Tuotteen Hintalinkki',
    sk: 'Odkaz na Cenu Položky',
    bg: 'Връзка към Цената на Артикул',
    hr: 'Poveznica na Cijenu Artikla',
    lt: 'Prekės Kainos Nuoroda',
    lv: 'Preces Cenas Saite',
    et: 'Toote Hinnalink',
    sl: 'Povezava do Cene Artikla',
    ga: 'Nasc Praghas Míre',
    mt: 'Link tal-Prezz tal-Oġġett',
    cy: 'Dolen Pris Eitem',
    ro: 'Link de Preț Articol',
    it: 'Link del Prezzo dell’Articolo',
    zh_cn: '商品价格链接',
    hi: 'आइटम मूल्य लिंक',
    ar: 'رابط سعر العنصر',
    bn: 'আইটেমের মূল্য লিঙ্ক',
    ru: 'Ссылка на Цену Товара',
    ja: 'アイテム価格リンク',
    tr: 'Ürün Fiyat Bağlantısı',
    ko: '상품 가격 링크',
    vi: 'Liên Kết Giá Mặt Hàng',
    id: 'Tautan Harga Item',
    th: 'ลิงก์ราคาสินค้า',
    ms: 'Pautan Harga Item',
    ar_eg: 'رابط سعر العنصر',
    uk: 'Посилання на Ціну Товару',
  },

  add_item_availability_link: {
    en: 'Add Item Availability Link',
    es: 'Agregar Enlace de Disponibilidad de Artículo',
    fr: 'Ajouter un Lien de Disponibilité de l’Article',
    de: 'Artikelverfügbarkeitslink Hinzufügen',
    pt: 'Adicionar Link de Disponibilidade do Item',
    pl: 'Dodaj Link Dostępności Produktu',
    nl: 'Artikelbeschikbaarheidskoppeling Toevoegen',
    el: 'Προσθήκη Συνδέσμου Διαθεσιμότητας Αντικειμένου',
    cs: 'Přidat Odkaz na Dostupnost Položky',
    sv: 'Lägg till Länk för Artikel Tillgänglighet',
    hu: 'Cikk Elérhetőségi Link Hozzáadása',
    da: 'Tilføj Link til Varetilgængelighed',
    fi: 'Lisää Tuotteen Saatavuuslinkki',
    sk: 'Pridať Odkaz na Dostupnosť Položky',
    bg: 'Добавяне на Връзка за Наличност на Артикул',
    hr: 'Dodaj Poveznicu za Dostupnost Artikla',
    lt: 'Pridėti Prekės Prieinamumo Nuorodą',
    lv: 'Pievienot Preces Pieejamības Saiti',
    et: 'Lisa Toote Saadavuse Link',
    sl: 'Dodaj Povezavo do Razpoložljivosti Artikla',
    ga: 'Cuir Nasc Infhaighteachta Míre leis',
    mt: 'Żid Link tal-Disponibbiltà tal-Oġġett',
    cy: 'Ychwanegu Dolen Argaeledd Eitem',
    ro: 'Adaugă Link de Disponibilitate Articol',
    it: 'Aggiungi Link di Disponibilità dell’Articolo',
    zh_cn: '添加商品可用性链接',
    hi: 'आइटम उपलब्धता लिंक जोड़ें',
    ar: 'إضافة رابط توافر العنصر',
    bn: 'আইটেম প্রাপ্যতা লিঙ্ক যোগ করুন',
    ru: 'Добавить Ссылку на Доступность Товара',
    ja: 'アイテム在庫リンクを追加',
    tr: 'Ürün Kullanılabilirlik Bağlantısı Ekle',
    ko: '상품 재고 링크 추가',
    vi: 'Thêm Liên Kết Tình Trạng Sẵn Có của Mặt Hàng',
    id: 'Tambahkan Tautan Ketersediaan Item',
    th: 'เพิ่มลิงก์ความพร้อมใช้งานของสินค้า',
    ms: 'Tambah Pautan Ketersediaan Item',
    ar_eg: 'إضافة رابط توافر العنصر',
    uk: 'Додати Посилання на Наявність Товару',
  },
  connect: {
    en: 'Connect',
    es: 'Conectar',
    fr: 'Connecter',
    de: 'Verbinden',
    pt: 'Conectar',
    pl: 'Połącz',
    nl: 'Verbinden',
    el: 'Σύνδεση',
    cs: 'Připojit',
    sv: 'Anslut',
    hu: 'Csatlakozás',
    da: 'Opret forbindelse',
    fi: 'Yhdistä',
    sk: 'Pripojiť',
    bg: 'Свързване',
    hr: 'Poveži',
    lt: 'Prijungti',
    lv: 'Pievienot',
    et: 'Ühenda',
    sl: 'Poveži',
    ga: 'Ceangail',
    mt: 'Qabbad',
    cy: 'Cysylltu',
    ro: 'Conectează',
    it: 'Connetti',
    zh_cn: '连接',
    hi: 'कनेक्ट करें',
    ar: 'اتصال',
    bn: 'সংযোগ করুন',
    ru: 'Подключить',
    ja: '接続',
    tr: 'Bağlan',
    ko: '연결',
    vi: 'Kết nối',
    id: 'Hubungkan',
    th: 'เชื่อมต่อ',
    ms: 'Sambung',
    ar_eg: 'اتصال',
    uk: 'Підключити',
  },
  multi_select: {
    selected: {
      en: 'selected',
      es: 'seleccionados',
      fr: 'sélectionnés',
      de: 'ausgewählt',
      pt: 'selecionados',
      pl: 'wybranych',
      nl: 'geselecteerd',
      el: 'επιλεγμένα',
      cs: 'vybráno',
      sv: 'valda',
      hu: 'kiválasztva',
      da: 'valgt',
      fi: 'valittua',
      sk: 'vybraných',
      bg: 'избрани',
      hr: 'odabrano',
      lt: 'pasirinkta',
      lv: 'atlasīts',
      et: 'valitud',
      sl: 'izbranih',
      ga: 'roghnaithe',
      mt: 'magħżula',
      cy: "wedi'u dewis",
      ro: 'selectate',
      it: 'selezionati',
      zh_cn: '已选中',
      hi: 'चुने गए',
      ar: 'محدد',
      bn: 'নির্বাচিত',
      ru: 'выбрано',
      ja: '個選択中',
      tr: 'seçili',
      ko: '선택됨',
      vi: 'đã chọn',
      id: 'dipilih',
      th: 'เลือกแล้ว',
      ms: 'dipilih',
      ar_eg: 'محدد',
      uk: 'вибрано',
    },
    alignment: {
      en: 'Alignment',
      es: 'Alineación',
      fr: 'Alignement',
      de: 'Ausrichtung',
      pt: 'Alinhamento',
      pl: 'Wyrównanie',
      nl: 'Uitlijning',
      el: 'Ευθυγράμμιση',
      cs: 'Zarovnání',
      sv: 'Justering',
      hu: 'Igazítás',
      da: 'Justering',
      fi: 'Tasaus',
      sk: 'Zarovnanie',
      bg: 'Подравняване',
      hr: 'Poravnanje',
      lt: 'Lygiavimas',
      lv: 'Līdzināšana',
      et: 'Joondamine',
      sl: 'Poravnanje',
      ga: 'Ailíniú',
      mt: 'Allinjament',
      cy: 'Alinio',
      ro: 'Aliniere',
      it: 'Allineamento',
      zh_cn: '对齐',
      hi: 'संरेखण',
      ar: 'محاذاة',
      bn: 'সংযোজন',
      ru: 'Выравнивание',
      ja: '整列',
      tr: 'Hizalama',
      ko: '정렬',
      vi: 'Căn chỉnh',
      id: 'Perataan',
      th: 'การจัดแนว',
      ms: 'Penjajaran',
      ar_eg: 'محاذاة',
      uk: 'Вирівнювання',
    },
    rotation: {
      en: 'Rotation',
      es: 'Rotación',
      fr: 'Rotation',
      de: 'Rotation',
      pt: 'Rotação',
      pl: 'Obrót',
      nl: 'Rotatie',
      el: 'Περιστροφή',
      cs: 'Rotace',
      sv: 'Rotation',
      hu: 'Forgatás',
      da: 'Rotation',
      fi: 'Kierto',
      sk: 'Rotácia',
      bg: 'Завъртане',
      hr: 'Rotacija',
      lt: 'Sukimas',
      lv: 'Rotācija',
      et: 'Pööramine',
      sl: 'Rotacija',
      ga: 'Rothlú',
      mt: 'Rotazzjoni',
      cy: 'Cylchdroi',
      ro: 'Rotație',
      it: 'Rotazione',
      zh_cn: '旋转',
      hi: 'घुमाव',
      ar: 'دوران',
      bn: 'ঘূর্ণন',
      ru: 'Вращение',
      ja: '回転',
      tr: 'Döndürme',
      ko: '회전',
      vi: 'Xoay',
      id: 'Rotasi',
      th: 'การหมุน',
      ms: 'Putaran',
      ar_eg: 'دوران',
      uk: 'Обертання',
    },
    deg: {
      en: 'deg',
      es: 'grados',
      fr: 'degrés',
      de: 'Grad',
      pt: 'graus',
      pl: 'stopni',
      nl: 'graden',
      el: 'μοίρες',
      cs: 'stupňů',
      sv: 'grader',
      hu: 'fok',
      da: 'grader',
      fi: 'astetta',
      sk: 'stupňov',
      bg: 'градуса',
      hr: 'stupnjeva',
      lt: 'laipsnių',
      lv: 'grādi',
      et: 'kraadi',
      sl: 'stopinj',
      ga: 'céim',
      mt: 'grad',
      cy: 'gradd',
      ro: 'grade',
      it: 'gradi',
      zh_cn: '度',
      hi: 'डिग्री',
      ar: 'درجة',
      bn: 'ডিগ্রি',
      ru: 'градусов',
      ja: '度',
      tr: 'derece',
      ko: '도',
      vi: 'độ',
      id: 'derajat',
      th: 'องศา',
      ms: 'darjah',
      ar_eg: 'درجة',
      uk: 'градусів',
    },
    gap: {
      en: 'Gap',
      es: 'Brecha',
      fr: 'Écart',
      de: 'Abstand',
      pt: 'Espaço',
      pl: 'Odstęp',
      nl: 'Ruimte',
      el: 'Κενό',
      cs: 'Mezera',
      sv: 'Mellanrum',
      hu: 'Távolság',
      da: 'Mellemrum',
      fi: 'Väli',
      sk: 'Medzera',
      bg: 'Разстояние',
      hr: 'Razmak',
      lt: 'Tarpas',
      lv: 'Atstarpe',
      et: 'Vahe',
      sl: 'Razmik',
      ga: 'Bearna',
      mt: 'Spazju',
      cy: 'Bwlch',
      ro: 'Spațiu',
      it: 'Spazio',
      zh_cn: '间距',
      hi: 'अंतर',
      ar: 'فجوة',
      bn: 'ব্যবধান',
      ru: 'Зазор',
      ja: '間隔',
      tr: 'Boşluk',
      ko: '간격',
      vi: 'Khoảng cách',
      id: 'Celah',
      th: 'ช่องว่าง',
      ms: 'Jurang',
      ar_eg: 'فجوة',
      uk: 'Зазор',
    },
    distribute_horizontally: {
      en: 'Distribute horizontally',
      es: 'Distribuir horizontalmente',
      fr: 'Distribuer horizontalement',
      de: 'Horizontal verteilen',
      pt: 'Distribuir horizontalmente',
      pl: 'Rozłóż poziomo',
      nl: 'Horizontaal verdelen',
      el: 'Οριζόντια διανομή',
      cs: 'Rozdělit vodorovně',
      sv: 'Fördela horisontellt',
      hu: 'Vízszintes elosztás',
      da: 'Fordel vandret',
      fi: 'Jaa vaakasuunnassa',
      sk: 'Rozdeliť vodorovne',
      bg: 'Разпределяне хоризонтално',
      hr: 'Rasporedi vodoravno',
      lt: 'Paskirstyti horizontaliai',
      lv: 'Sadalīt horizontāli',
      et: 'Jaota horisontaalselt',
      sl: 'Porazdeli vodoravno',
      ga: 'Dáileadh cothrománach',
      mt: 'Distribuzzjoni orizzontali',
      cy: "Dosbarthu'n llorweddol",
      ro: 'Distribuire orizontal',
      it: 'Distribuisci orizzontalmente',
      zh_cn: '水平分布',
      hi: 'क्षैतिज वितरण',
      ar: 'توزيع أفقي',
      bn: 'অনুভূমিক বিতরণ',
      ru: 'Распределить горизонтально',
      ja: '水平に配置',
      tr: 'Yatay dağıt',
      ko: '수평 배분',
      vi: 'Phân phối theo chiều ngang',
      id: 'Distribusi horizontal',
      th: 'แจกแจงแนวนอน',
      ms: 'Agihkan secara mendatar',
      ar_eg: 'توزيع أفقي',
      uk: 'Розподілити горизонтально',
    },
    distribute_vertically: {
      en: 'Distribute vertically',
      es: 'Distribuir verticalmente',
      fr: 'Distribuer verticalement',
      de: 'Vertikal verteilen',
      pt: 'Distribuir verticalmente',
      pl: 'Rozłóż pionowo',
      nl: 'Verticaal verdelen',
      el: 'Κάθετη διανομή',
      cs: 'Rozdělit svisle',
      sv: 'Fördela vertikalt',
      hu: 'Függőleges elosztás',
      da: 'Fordel lodret',
      fi: 'Jaa pystysuunnassa',
      sk: 'Rozdeliť zvisle',
      bg: 'Разпределяне вертикално',
      hr: 'Rasporedi okomito',
      lt: 'Paskirstyti vertikaliai',
      lv: 'Sadalīt vertikāli',
      et: 'Jaota vertikaalselt',
      sl: 'Porazdeli navpično',
      ga: 'Dáileadh ingearach',
      mt: 'Distribuzzjoni vertikali',
      cy: "Dosbarthu'n fertigol",
      ro: 'Distribuire vertical',
      it: 'Distribuisci verticalmente',
      zh_cn: '垂直分布',
      hi: 'ऊर्ध्वाधर वितरण',
      ar: 'توزيع عمودي',
      bn: 'উল্লম্ব বিতরণ',
      ru: 'Распределить вертикально',
      ja: '垂直に配置',
      tr: 'Dikey dağıt',
      ko: '수직 배분',
      vi: 'Phân phối theo chiều dọc',
      id: 'Distribusi vertikal',
      th: 'แจกแจงแนวตั้ง',
      ms: 'Agihkan secara menegak',
      ar_eg: 'توزيع عمودي',
      uk: 'Розподілити вертикально',
    },
    duplicate: {
      en: 'Duplicate',
      es: 'Duplicar',
      fr: 'Dupliquer',
      de: 'Duplizieren',
      pt: 'Duplicar',
      pl: 'Duplikuj',
      nl: 'Dupliceren',
      el: 'Αντιγράψτε',
      cs: 'Duplikovat',
      sv: 'Duplicera',
      hu: 'Másolat',
      da: 'Duplikat',
      fi: 'Kopioi',
      sk: 'Duplikovať',
      bg: 'Дублиране',
      hr: 'Dupliciraj',
      lt: 'Dubliuoti',
      lv: 'Dublicēt',
      et: 'Dubleeri',
      sl: 'Podvoji',
      ga: 'Dúbligh',
      mt: 'Idduplika',
      cy: 'Dyblygu',
      ro: 'Duplica',
      it: 'Duplica',
      zh_cn: '复制',
      hi: 'डुप्लिकेट',
      ar: 'تكرار',
      bn: 'ডুপ্লিকেট',
      ru: 'Дублировать',
      ja: '複製',
      tr: 'Çoğalt',
      ko: '복제',
      vi: 'Nhân bản',
      id: 'Duplikat',
      th: 'ทำซ้ำ',
      ms: 'Salin',
      ar_eg: 'تكرار',
      uk: 'Дублювати',
    },
    delete: {
      en: 'Delete',
      es: 'Eliminar',
      fr: 'Supprimer',
      de: 'Löschen',
      pt: 'Excluir',
      pl: 'Usuń',
      nl: 'Verwijderen',
      el: 'Διαγραφή',
      cs: 'Smazat',
      sv: 'Radera',
      hu: 'Törlés',
      da: 'Slet',
      fi: 'Poista',
      sk: 'Odstrániť',
      bg: 'Изтрий',
      hr: 'Izbriši',
      lt: 'Ištrinti',
      lv: 'Dzēst',
      et: 'Kustuta',
      sl: 'Izbriši',
      ga: 'Scrios',
      mt: 'Ħassar',
      cy: 'Dileu',
      ro: 'Șterge',
      it: 'Elimina',
      zh_cn: '删除',
      hi: 'हटाएं',
      ar: 'حذف',
      bn: 'মুছুন',
      ru: 'Удалить',
      ja: '削除',
      tr: 'Sil',
      ko: '삭제',
      vi: 'Xóa',
      id: 'Hapus',
      th: 'ลบ',
      ms: 'Padam',
      ar_eg: 'حذف',
      uk: 'Видалити',
    },
    delete_title: {
      en: 'Are You Sure You Want to Delete Selected Items?',
      es: '¿Estás Seguro de Que Quieres Eliminar los Elementos Seleccionados?',
      fr: 'Êtes-Vous Sûr de Vouloir Supprimer les Éléments Sélectionnés ?',
      de: 'Sind Sie Sicher, Dass Sie die Ausgewählten Elemente Löschen Möchten?',
      pt: 'Tem Certeza de Que Deseja Excluir os Itens Selecionados?',
      pl: 'Czy Na Pewno Chcesz Usunąć Wybrane Elementy?',
      nl: 'Weet U Zeker Dat U de Geselecteerde Items Wilt Verwijderen?',
      el: 'Είστε Σίγουροι ότι Θέλετε να Διαγράψετε τα Επιλεγμένα Στοιχεία;',
      cs: 'Opravdu Chcete Smazat Vybrané Položky?',
      sv: 'Är Du Säker på att Du Vill Radera de Valda Objekten?',
      hu: 'Biztosan Törölni Szeretné a Kiválasztott Elemeket?',
      da: 'Er Du Sikker på, at Du Vil Slette de Valgte Elementer?',
      fi: 'Oletko Varma, Että Haluat Poistaa Valitut Kohteet?',
      sk: 'Ste Si Istí, že Chcete Odstrániť Vybrané Položky?',
      bg: 'Сигурни ли Сте, че Искате да Изтриете Избраните Елементи?',
      hr: 'Jeste li Sigurni da Želite Izbrisati Odabrane Stavke?',
      lt: 'Ar Tikrai Norite Ištrinti Pasirinktus Elementus?',
      lv: 'Vai Tiešām Vēlaties Dzēst Atlasītos Vienumus?',
      et: 'Kas Olete Kindel, et Soovite Valitud Üksused Kustutada?',
      sl: 'Ali Ste Prepričani, da Želite Izbrisati Izbrane Elemente?',
      ga: 'An Bhfuil Tú Cinnte Gur Mian Leat na Míreanna Roghnaithe a Scriosadh?',
      mt: 'Żgur Li Trid Tħassar l-Oġġetti Magħżula?',
      cy: "Ydych Chi'n Siŵr Eich Bod Chi am Ddileu'r Eitemau Dethol?",
      ro: 'Sigur Vrei Să Ștergi Elementele Selectate?',
      it: 'Sei Sicuro di Voler Eliminare gli Elementi Selezionati?',
      zh_cn: '您确定要删除选定的项目吗？',
      hi: 'क्या आप वाकई चुने हुए आइटम हटाना चाहते हैं?',
      ar: 'هل أنت متأكد أنك تريد حذف العناصر المحددة؟',
      bn: 'আপনি কি নিশ্চিত যে আপনি নির্বাচিত আইটেমগুলি মুছতে চান?',
      ru: 'Вы Уверены, что Хотите Удалить Выбранные Элементы?',
      ja: '選択したアイテムを削除してもよろしいですか？',
      tr: 'Seçili Öğeleri Silmek İstediğinizden Emin misiniz?',
      ko: '선택한 항목을 삭제하시겠습니까?',
      vi: 'Bạn Có Chắc Muốn Xóa Các Mục Đã Chọn Không?',
      id: 'Apakah Anda Yakin Ingin Menghapus Item yang Dipilih?',
      th: 'คุณแน่ใจหรือไม่ว่าต้องการลบรายการที่เลือก?',
      ms: 'Adakah Anda Pasti Mahu Memadam Item yang Dipilih?',
      ar_eg: 'هل أنت متأكد أنك تريد حذف العناصر المحددة؟',
      uk: 'Ви Впевнені, що Хочете Видалити Вибрані Елементи?',
    },
  },
  toolbar: {
    multi_select: {
      en: 'Multi Select',
      es: 'Selección múltiple',
      fr: 'Sélection multiple',
      de: 'Mehrfachauswahl',
      pt: 'Seleção múltipla',
      pl: 'Wielokrotny wybór',
      nl: 'Meervoudige selectie',
      el: 'Πολλαπλή επιλογή',
      cs: 'Vícenásobný výběr',
      sv: 'Flerval',
      hu: 'Többszörös kijelölés',
      da: 'Flervalg',
      fi: 'Monivalinta',
      sk: 'Viacnásobný výber',
      bg: 'Множествен избор',
      hr: 'Višestruki odabir',
      lt: 'Kelių pasirinkimas',
      lv: 'Vairāku atlase',
      et: 'Mitmikvalik',
      sl: 'Večkratna izbira',
      ga: 'Il-roghnú',
      mt: 'Għażla multipla',
      cy: 'Aml-ddewis',
      ro: 'Selecție multiplă',
      it: 'Selezione multipla',
      zh_cn: '多选',
      hi: 'बहु चयन',
      ar: 'تحديد متعدد',
      bn: 'একাধিক নির্বাচন',
      ru: 'Множественный выбор',
      ja: '複数選択',
      tr: 'Çoklu seçim',
      ko: '다중 선택',
      vi: 'Chọn nhiều',
      id: 'Pilihan ganda',
      th: 'เลือกหลายรายการ',
      ms: 'Pilihan berbilang',
      ar_eg: 'تحديد متعدد',
      uk: 'Множинний вибір',
    },
    undo: {
      en: 'Undo',
      es: 'Deshacer',
      fr: 'Annuler',
      de: 'Rückgängig',
      pt: 'Desfazer',
      pl: 'Cofnij',
      nl: 'Ongedaan maken',
      el: 'Αναίρεση',
      cs: 'Zpět',
      sv: 'Ångra',
      hu: 'Visszavonás',
      da: 'Fortryd',
      fi: 'Kumoa',
      sk: 'Späť',
      bg: 'Отмяна',
      hr: 'Poništi',
      lt: 'Atšaukti',
      lv: 'Atsaukt',
      et: 'Võta tagasi',
      sl: 'Razveljavi',
      ga: 'Cealaigh',
      mt: 'Aħjar lura',
      cy: 'Dadwneud',
      ro: 'Anulare',
      it: 'Annulla',
      zh_cn: '撤销',
      hi: 'पूर्ववत करें',
      ar: 'تراجع',
      bn: 'পূর্বাবস্থায় ফেরান',
      ru: 'Отменить',
      ja: '元に戻す',
      tr: 'Geri Al',
      ko: '실행 취소',
      vi: 'Hoàn tác',
      id: 'Urungkan',
      th: 'เลิกทำ',
      ms: 'Buat asal',
      ar_eg: 'تراجع',
      uk: 'Скасувати',
    },
    redo: {
      en: 'Redo',
      es: 'Rehacer',
      fr: 'Rétablir',
      de: 'Wiederholen',
      pt: 'Refazer',
      pl: 'Ponów',
      nl: 'Opnieuw uitvoeren',
      el: 'Επαναφορά',
      cs: 'Znovu',
      sv: 'Gör om',
      hu: 'Mégis',
      da: 'Gentag',
      fi: 'Tee uudelleen',
      sk: 'Znova',
      bg: 'Повторение',
      hr: 'Ponovi',
      lt: 'Perdaryti',
      lv: 'Pārtaisīt',
      et: 'Tee uuesti',
      sl: 'Ponovi',
      ga: 'Athdhéan',
      mt: "Erġa' agħmel",
      cy: 'Ailwneud',
      ro: 'Refacere',
      it: 'Ripristina',
      zh_cn: '重做',
      hi: 'फिर से करें',
      ar: 'إعادة',
      bn: 'পুনরায় করুন',
      ru: 'Повторить',
      ja: 'やり直す',
      tr: 'Yeniden Yap',
      ko: '다시 실행',
      vi: 'Làm lại',
      id: 'Ulangi',
      th: 'ทำซ้ำ',
      ms: 'Buat semula',
      ar_eg: 'إعادة',
      uk: 'Повторити',
    },
  },
  layout_grid: {
    title: {
      en: 'Layout grid',
      es: 'Cuadrícula de diseño',
      fr: 'Grille de mise en page',
      de: 'Layoutraster',
      pt: 'Grade de layout',
      pl: 'Siatka układu',
      nl: 'Lay-outraster',
      el: 'Πλέγμα διάταξης',
      cs: 'Mřížka rozvržení',
      sv: 'Layoutrutnät',
      hu: 'Elrendezési rács',
      da: 'Layoutgitter',
      fi: 'Asetteluruudukko',
      sk: 'Mriežka rozloženia',
      bg: 'Мрежа на оформлението',
      hr: 'Mreža rasporeda',
      lt: 'Išdėstymo tinklelis',
      lv: 'Izkārtojuma režģis',
      et: 'Paigutusruudustik',
      sl: 'Mreža postavitve',
      ga: 'Greille leagain amach',
      mt: 'Grilja tat-tqassim',
      cy: 'Grid cynllun',
      ro: 'Grilă de aspect',
      it: 'Griglia di layout',
      zh_cn: '布局网格',
      hi: 'लेआउट ग्रिड',
      ar: 'شبكة التخطيط',
      bn: 'লেআউট গ্রিড',
      ru: 'Сетка макета',
      ja: 'レイアウトグリッド',
      tr: 'Düzen ızgarası',
      ko: '레이아웃 그리드',
      vi: 'Lưới bố cục',
      id: 'Kisi tata letak',
      th: 'กริดเลย์เอาต์',
      ms: 'Grid susun atur',
      ar_eg: 'شبكة التخطيط',
      uk: 'Сітка макета',
    },
    show: {
      en: 'Show grid',
      es: 'Mostrar cuadrícula',
      fr: 'Afficher la grille',
      de: 'Raster anzeigen',
      pt: 'Mostrar grade',
      pl: 'Pokaż siatkę',
      nl: 'Raster tonen',
      el: 'Εμφάνιση πλέγματος',
      cs: 'Zobrazit mřížku',
      sv: 'Visa rutnät',
      hu: 'Rács megjelenítése',
      da: 'Vis gitter',
      fi: 'Näytä ruudukko',
      sk: 'Zobraziť mriežku',
      bg: 'Показване на мрежата',
      hr: 'Prikaži mrežu',
      lt: 'Rodyti tinklelį',
      lv: 'Rādīt režģi',
      et: 'Kuva ruudustik',
      sl: 'Prikaži mrežo',
      ga: 'Taispeáin an ghreille',
      mt: 'Uri l-grilja',
      cy: 'Dangos y grid',
      ro: 'Afișează grila',
      it: 'Mostra griglia',
      zh_cn: '显示网格',
      hi: 'ग्रिड दिखाएँ',
      ar: 'إظهار الشبكة',
      bn: 'গ্রিড দেখান',
      ru: 'Показать сетку',
      ja: 'グリッドを表示',
      tr: 'Izgarayı göster',
      ko: '그리드 표시',
      vi: 'Hiện lưới',
      id: 'Tampilkan kisi',
      th: 'แสดงกริด',
      ms: 'Tunjukkan grid',
      ar_eg: 'إظهار الشبكة',
      uk: 'Показати сітку',
    },
    description: {
      en: 'Items snap to the column edges while you move them',
      es: 'Los elementos se ajustan a los bordes de las columnas al moverlos',
      fr: 'Les éléments s’alignent sur les bords des colonnes lorsque vous les déplacez',
      de: 'Elemente rasten beim Verschieben an den Spaltenkanten ein',
      pt: 'Os itens se ajustam às bordas das colunas ao movê-los',
      pl: 'Elementy przyciągają się do krawędzi kolumn podczas przesuwania',
      nl: 'Items klikken vast aan de kolomranden terwijl je ze verplaatst',
      el: 'Τα στοιχεία κουμπώνουν στις άκρες των στηλών καθώς τα μετακινείτε',
      cs: 'Prvky se při přesouvání přichytávají k okrajům sloupců',
      sv: 'Objekt fäster mot kolumnkanterna när du flyttar dem',
      hu: 'Az elemek mozgatáskor az oszlopok széleihez igazodnak',
      da: 'Elementer fastgøres til kolonnekanterne, når du flytter dem',
      fi: 'Kohteet tarttuvat sarakkeiden reunoihin, kun siirrät niitä',
      sk: 'Prvky sa pri presúvaní prichytávajú k okrajom stĺpcov',
      bg: 'Елементите се прилепват към краищата на колоните, докато ги местите',
      hr: 'Stavke se pri pomicanju prianjaju uz rubove stupaca',
      lt: 'Perkeliami elementai prilimpa prie stulpelių kraštų',
      lv: 'Pārvietojot elementi pielīp kolonnu malām',
      et: 'Elemendid kinnituvad liigutamisel veergude servadele',
      sl: 'Elementi se med premikanjem pripnejo na robove stolpcev',
      ga: 'Greamaíonn míreanna d’imill na gcolún agus tú á mbogadh',
      mt: 'L-elementi jeħlu mat-truf tal-kolonni waqt li tiċċaqlaqhom',
      cy: 'Mae eitemau’n glynu wrth ymylon y colofnau wrth i chi eu symud',
      ro: 'Elementele se aliniază la marginile coloanelor când le mutați',
      it: 'Gli elementi si agganciano ai bordi delle colonne mentre li sposti',
      zh_cn: '移动项目时会吸附到列的边缘',
      hi: 'आइटम खिसकाते समय कॉलम के किनारों से चिपक जाते हैं',
      ar: 'تلتصق العناصر بحواف الأعمدة أثناء تحريكها',
      bn: 'সরানোর সময় আইটেমগুলো কলামের প্রান্তে আটকে যায়',
      ru: 'При перемещении элементы прилипают к краям колонок',
      ja: '移動中、アイテムが列の端にスナップします',
      tr: 'Öğeler taşınırken sütun kenarlarına yapışır',
      ko: '항목을 이동할 때 열 가장자리에 맞춰집니다',
      vi: 'Các mục sẽ bám vào mép cột khi bạn di chuyển chúng',
      id: 'Item menempel ke tepi kolom saat Anda memindahkannya',
      th: 'รายการจะยึดกับขอบคอลัมน์ขณะที่คุณย้าย',
      ms: 'Item melekat pada tepi lajur semasa anda mengalihkannya',
      ar_eg: 'العناصر بتلزق في حواف الأعمدة وانت بتحركها',
      uk: 'Під час переміщення елементи прилипають до країв колонок',
    },
    columns: {
      en: 'Columns',
      es: 'Columnas',
      fr: 'Colonnes',
      de: 'Spalten',
      pt: 'Colunas',
      pl: 'Kolumny',
      nl: 'Kolommen',
      el: 'Στήλες',
      cs: 'Sloupce',
      sv: 'Kolumner',
      hu: 'Oszlopok',
      da: 'Kolonner',
      fi: 'Sarakkeet',
      sk: 'Stĺpce',
      bg: 'Колони',
      hr: 'Stupci',
      lt: 'Stulpeliai',
      lv: 'Kolonnas',
      et: 'Veerud',
      sl: 'Stolpci',
      ga: 'Colúin',
      mt: 'Kolonni',
      cy: 'Colofnau',
      ro: 'Coloane',
      it: 'Colonne',
      zh_cn: '列数',
      hi: 'कॉलम',
      ar: 'الأعمدة',
      bn: 'কলাম',
      ru: 'Колонки',
      ja: '列',
      tr: 'Sütunlar',
      ko: '열',
      vi: 'Cột',
      id: 'Kolom',
      th: 'คอลัมน์',
      ms: 'Lajur',
      ar_eg: 'الأعمدة',
      uk: 'Колонки',
    },
    gutter: {
      en: 'Gutter',
      es: 'Medianil',
      fr: 'Gouttière',
      de: 'Spaltenabstand',
      pt: 'Espaçamento',
      pl: 'Odstęp',
      nl: 'Tussenruimte',
      el: 'Διάκενο',
      cs: 'Mezera',
      sv: 'Mellanrum',
      hu: 'Térköz',
      da: 'Mellemrum',
      fi: 'Väli',
      sk: 'Medzera',
      bg: 'Междина',
      hr: 'Razmak',
      lt: 'Tarpas',
      lv: 'Atstarpe',
      et: 'Vahe',
      sl: 'Razmik',
      ga: 'Bearna',
      mt: 'Spazju',
      cy: 'Bwlch',
      ro: 'Spațiere',
      it: 'Spaziatura',
      zh_cn: '间距',
      hi: 'गटर',
      ar: 'التباعد',
      bn: 'গাটার',
      ru: 'Промежуток',
      ja: 'ガター',
      tr: 'Oluk',
      ko: '거터',
      vi: 'Khoảng cách',
      id: 'Jarak antarkolom',
      th: 'ระยะห่าง',
      ms: 'Jarak',
      ar_eg: 'المسافة',
      uk: 'Проміжок',
    },
    margin: {
      en: 'Margin',
      es: 'Margen',
      fr: 'Marge',
      de: 'Rand',
      pt: 'Margem',
      pl: 'Margines',
      nl: 'Marge',
      el: 'Περιθώριο',
      cs: 'Okraj',
      sv: 'Marginal',
      hu: 'Margó',
      da: 'Margen',
      fi: 'Marginaali',
      sk: 'Okraj',
      bg: 'Поле',
      hr: 'Margina',
      lt: 'Paraštė',
      lv: 'Mala',
      et: 'Veeris',
      sl: 'Rob',
      ga: 'Imeall',
      mt: 'Marġni',
      cy: 'Ymyl',
      ro: 'Margine',
      it: 'Margine',
      zh_cn: '边距',
      hi: 'मार्जिन',
      ar: 'الهامش',
      bn: 'মার্জিন',
      ru: 'Поле',
      ja: '余白',
      tr: 'Kenar boşluğu',
      ko: '여백',
      vi: 'Lề',
      id: 'Margin',
      th: 'ระยะขอบ',
      ms: 'Margin',
      ar_eg: 'الهامش',
      uk: 'Поле',
    },
  },
}

export default translate
